(function (sb) {
	sb.Toplines = {};

	const thumbnail = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="160" height="90"><path fill="%23E1E4E9" d="M160 0v90H0V0h160ZM71.1 29H57v33h14.1V29Zm16.45 14.143h-14.1V62h14.1V43.143ZM104 52.57H89.9V62H104v-9.429ZM104 29H89.9v21.214H104V29Zm-16.45 0h-14.1v11.786h14.1V29Z"/></svg>';

	const questionTypeIcons = {
		1: '<svg class="ags-template-category-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="m5.172-.485 11.313 11.313-1.414 1.415L3.757.929zM3.05 1.636 4.464 3.05 1.636 5.88.222 4.464zm9.9 9.9 1.414 1.414-2.828 2.828-1.415-1.414zM4.11 5.525 5.526 6.94 4.111 8.354 2.697 6.939zm4.95 4.95 1.415 1.414-1.414 1.414-1.415-1.414zM8 6.586 9.414 8l-2.828 2.828-1.414-1.414z" fill="#818D90" fill-rule="evenodd" opacity=".8"/></svg>',
		2: '<svg class="ags-template-category-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><g fill="#818D94" fill-rule="evenodd"><circle opacity=".4" cx="4.5" cy="4.5" r="3.5"/><circle opacity=".6" cx="11.5" cy="6.5" r="3.5"/><circle opacity=".8" cx="6.5" cy="11.5" r="3.5"/></g></svg>',
		3: '<svg class="ags-template-category-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><g fill="#818D94" fill-rule="evenodd"><circle opacity=".6" cx="5" cy="6" r="5"/><circle opacity=".4" cx="11" cy="6" r="5"/><circle opacity=".8" cx="8" cy="10" r="5"/></g></svg>',
		4: '<svg class="ags-template-category-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 1c3.866 0 7 2.523 7 5.636s-3.134 5.636-7 5.636c-.371 0-.736-.024-1.091-.068C5.405 13.694 3.61 13.96 1.875 14v-.365c.937-.455 1.75-1.283 1.75-2.23a2.5 2.5 0 0 0-.03-.389C2.012 9.983 1 8.405 1 6.636 1 3.523 4.134 1 8 1z" fill="#818D94" opacity=".8"/></svg>',
		5: '<svg class="ags-template-category-icon" width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2 2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm3 9V9.781H3.606V4H2.402l-1.305.347v1.247l1.297-.356V9.78H1V11h4zm5 0V9.803H7.346l.527-.58.5-.546c.574-.63.93-1.04 1.066-1.232.202-.289.345-.551.428-.788.083-.236.125-.49.125-.76 0-.586-.191-1.049-.572-1.388C9.039 4.169 8.515 4 7.848 4c-.264 0-.54.031-.829.094a5.66 5.66 0 0 0-.884.274v1.267c.301-.184.59-.325.867-.422a2.3 2.3 0 0 1 .75-.145c.311 0 .553.084.723.251.17.168.255.405.255.712 0 .2-.046.401-.14.606a3.488 3.488 0 0 1-.455.702c-.172.215-.658.787-1.46 1.718L6 9.839V11h4zm2.772 0c.725 0 1.278-.172 1.658-.515.38-.344.57-.842.57-1.496 0-.488-.115-.882-.345-1.182-.23-.3-.563-.492-1-.576.385-.078.682-.245.89-.5.207-.254.311-.581.311-.982 0-.545-.18-.973-.541-1.284-.361-.31-.864-.465-1.51-.465-.251 0-.514.025-.788.075a6.13 6.13 0 0 0-.832.214V5.5c.281-.12.553-.212.816-.275a3.16 3.16 0 0 1 .738-.095c.301 0 .535.07.7.21.165.14.248.335.248.585 0 .238-.083.423-.248.554-.165.13-.399.196-.7.196h-.648V7.85h.648c.35 0 .621.094.813.283.191.188.287.455.287.802 0 .283-.096.508-.287.675-.192.168-.451.251-.78.251-.328 0-.641-.037-.94-.11A3.423 3.423 0 0 1 11 9.426v1.239a4.851 4.851 0 0 0 1.772.334z" fill="#818D94" fill-rule="evenodd" opacity=".8"/></svg>'
	};

	const questionTypeText = {
		1: 'Scale',
		2: 'Single choice',
		3: 'Multi choice',
		4: 'Open ended',
		5: 'Numeric'
	}

	function getCategoryDefaultTemplate(toplineSet, questionType) {
		return toplineSet.templates
			.find(tp => !tp.isDeleted && tp.questionTypes?.find(qt => qt.questionTypeId === questionType));
	}

	function getCategoryTemplatesWithConditions(toplineSet, questionType) {
		return toplineSet.templates
			.filter(tp => !tp.isDeleted && tp.conditionGroups?.find(qt => qt.questionTypeId === questionType))
			.sort((a, b) => a.sortOrder - b.sortOrder);
	}

	function isSingleQuestion() {
		const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
		const slideElements = Storyboard.LayoutDesigner.getLayoutElementsBySlide(currentSlide);

		for (var elemIndex in slideElements)
			if (slideElements.hasOwnProperty(elemIndex)) {
				if (Storyboard.LayoutDesigner.getLayoutElementType(slideElements[elemIndex]) == Storyboard.Constants.itemTypes.SUMMARY)
					return true;
			}

		return false;
	}

	class QuestionsSelect {
		constructor() {
			this.questions = [];
			this.availableQuestions = [];
			this.selectedQuestions = [];
			this.selectedSlides = [];
			this.filters = [];
			this.slides = [];
			this.questionsForGrouping = [];
			this.sameFilteringSelection = true;
		}

		loadQuestions() {
			const filter = '';
			const calculationType = '';
			const questionBlocks = sb.Toplines.questionsFilter.options.questionBlocks;
			const variableSubsets = '';
			const gridQuestions = '';
			const filterByCode = false;
			const excludedQnTypes = '';
			const maxNoOfAnswers = 0;
			const excludeNoDataQns = false;

			ChartSetupProxy.GetFilterQuestions(
				filter,
				calculationType,
				questionBlocks,
				variableSubsets,
				gridQuestions,
				filterByCode,
				excludedQnTypes,
				maxNoOfAnswers,
				excludeNoDataQns,
				(questions) => this.bindQuestions(questions)
			);
		}

		filterQuestions() {
			const filter = $('#agsAvailableQuestionSearch').val();
			const calculationType = '';
			const questionBlocks = sb.Toplines.questionsFilter.options.questionBlocks;
			const variableSubsets = '';
			const gridQuestions = '';
			const filterByCode = $("#agsShowQuestionCode").is(':checked');
			const excludedQnTypes = sb.Toplines.questionsFilter.options.excludedQnTypes || '';
			const maxNoOfAnswers = sb.Toplines.questionsFilter.options.hideMoreAnswers ? sb.Toplines.questionsFilter.options.maxNoOfAnswers : 0;
			const excludeNoDataQns = sb.Toplines.questionsFilter.options.excludeNoDataQns;

			this.bindQuestionsFilterActiveStatus();

			ChartSetupProxy.GetFilterQuestions(
				filter,
				calculationType,
				questionBlocks,
				variableSubsets,
				gridQuestions,
				filterByCode,
				excludedQnTypes,
				maxNoOfAnswers,
				excludeNoDataQns,
				(questions) => this.bindQuestions(questions)
			);
		}

		bindQuestions(questions = []) {
			this.questions = questions.filter(q => q.questionT !== 7);
			this.availableQuestions = this.questions;

			if (this.selectedQuestions.length > 0) {
				const selectedQuestionIDs = this.selectedQuestions.map(q => q.questionId);
				this.availableQuestions = this.questions.filter(q => !selectedQuestionIDs.includes(q.questionId));
			}

			this.renderQuestions(true);
			this.bindEvents();
		}

		searchAvailableQuestions(event) {
			if (event.key !== 'Shift' && !event.metaKey && !event.ctrlKey)
				this.filterQuestions();
		}

		searchSelectedQuestions(event) {
			if (event.key !== 'Shift' && !event.metaKey && !event.ctrlKey)
				this.renderQuestions();
		}

		getSlideByGuid(guid) {
			return this.slides.find(s => s.guid === guid);
		}

		getQuestionById(id) {
			return this.questions.find(q => q.questionId == id) ||
				this.availableQuestions.find(q => q.questionId == id) ||
				this.selectedQuestions.find(q => q.questionId == id);
		}

		getQuestionsByIds(ids = []) {
			const idNumbers = ids.map(Number);
			return idNumbers.map(id => this.getQuestionById(id)).filter(Boolean);
		}

		addAllQuestions() {
			this.selectedQuestions = [...this.selectedQuestions, ...this.availableQuestions];
			this.slides = [
				...this.slides,
				...this.availableQuestions.map(q => ({
					guid: Helpers.generateGuid(),
					questionType: q.questionT,
					questionIDs: [q.questionId],
				}))
			];

			this.availableQuestions = [];
		}

		addQuestions(questions, slideGuid, index) {
			const questionIDs = questions.map(q => q.questionId);
			const hasIndex = typeof index === 'number' && !isNaN(index) && index > -1;
			this.availableQuestions = this.availableQuestions.filter(q => !questionIDs.includes(q.questionId));

			for (const question of questions) {
				if (!this.selectedQuestions.includes(question)) {
					this.selectedQuestions.push(question);
				}
			}

			if (slideGuid) {
				let slide = this.getSlideByGuid(slideGuid);
				if (slide) {
					if (hasIndex) {
						slide.questionIDs.splice(index, 0, ...questionIDs);
					} else {
						slide.questionIDs.push(...questionIDs);
					}
				}
			} else {
				let newSlides = questions.map(q => ({
					guid: Helpers.generateGuid(),
					questionType: q.questionT,
					questionIDs: [q.questionId],
				}));
				if (hasIndex) {
					this.slides.splice(index, 0, ...newSlides);
				} else {
					this.slides.push(...newSlides);
				}
			}
		}

		removeQuestions(questions, slideGuid) {
			const questionIDs = questions.map(q => q.questionId);
			this.availableQuestions = this.sortAvailableQuestions([...this.availableQuestions, ...questions]);
			this.selectedQuestions = this.selectedQuestions.filter(q => !questionIDs.includes(q.questionId));

			if (slideGuid) {
				const selectedSlide = this.slides.find(slide => slide.guid === slideGuid);
				selectedSlide.questionIDs = selectedSlide.questionIDs.filter(q => !questionIDs.includes(q));
				if (selectedSlide.questionIDs.length === 0) {
					this.slides = this.slides.filter(slide => slide.guid !== slideGuid);
				}
			} else {
				this.slides = this.slides.filter(slide => !(slide.questionIDs.length === 1 && questionIDs.includes(slide.questionIDs[0])));
			}
		}

		removeAllQuestions() {
			this.availableQuestions = this.sortAvailableQuestions([...this.availableQuestions, ...this.selectedQuestions]);
			this.selectedQuestions = [];
			this.slides = [];
		}

		sortAvailableQuestions(questionsToSort) {
			const sortKeys = this.questions.map(q => q.questionId);
			return questionsToSort.sort((v1, v2) => sortKeys.indexOf(v1.questionId) - sortKeys.indexOf(v2.questionId));
		}

		filterSelectedQuestions(questions, showCode) {
			const selectedQuestionSearch = ($('#agsSelectedQuestionSearch').val() ?? '').toLowerCase();

			if (selectedQuestionSearch.length > 0) {
				return questions.filter(q => {
					if (showCode) {
						return q.code.toLowerCase().includes(selectedQuestionSearch) ||
							q.questionText.toLowerCase().includes(selectedQuestionSearch);
					}
	
					return q.questionText.toLowerCase().includes(selectedQuestionSearch);
				});
			} else {
				return questions;
			}
		}

		renderQuestions(validateSteps) {
			const availableQuestionsList = $('#agsAvailableQuestions').empty();
			const selectedQuestionsList = $('#agsSelectedQuestions').empty();
			const showCode = $('#agsShowQuestionCode').is(':checked');

			let { availableQuestions, slides } = this;

			const sortedAvailableQuestions = this.sortAvailableQuestions(availableQuestions);

			availableQuestionsList.html(sortedAvailableQuestions.map((v) => this.getQuestionHTML(v, 0, null, showCode)).join(''));

			selectedQuestionsList.html(slides.map(slide => this.getSlideHTML(slide, showCode)).join(''));

			if (selectedQuestionsList.is(':empty')) {
				selectedQuestionsList.html('<p class="ags-questions-list-empty ags-questions-list-dropzone-info text-muted">Drop variables to be used for slides here</p>');
			} else {
				this.renderAnswerSelections();
			}

			this.bindQuestionsFilterActiveStatus();
			this.bindQuestionsOptionsAttributes();
			this.bindEvents();

			if (validateSteps)
				AutoGenerateSlides.validateSteps();
		}

		renderAnswerSelections() {
			const selectedQuestionElements = $('#agsSelectedQuestions .ags-question[data-question-id]');

			selectedQuestionElements.find('.badge').remove();

			selectedQuestionElements.each((index, el) => {
				const id = Number($(el).attr('data-question-id'));
				const question = this.getQuestionById(id);
				const selectedAnswers = sb.Toplines.answersSelect.selectedAnswers[question.answerBlockId];
				const selected = selectedAnswers ? selectedAnswers.length : 0;
				const total = question.ans;

				if (question && selectedAnswers) {
					$(el).append(` <span class="badge">${selected} of ${total} selected</span>`)
				}
			});
		}

		openAnswers(questionId) {
			const question = this.getQuestionById(questionId);

			if (question) {
				sb.Toplines.answersSelect.open(question);
			}
		}

		compareSlides(questionIDs) {
			const slides = this.slides.filter(slide => {
				if (slide.questionIDs.length > 1) {
					const slideQuestion = slide.questionIDs.find(q => questionIDs.includes(q));
					return !!slideQuestion;
				}
				
				return questionIDs.includes(slide.questionIDs[0])
			});

			slides.forEach((slide, index) => {
				if ((index + 1) < slides.length && ((JSON.stringify(slide?.filters) !== JSON.stringify(slides[index+1]?.filters)) || (!!slide?.nestFilterCompares !== !!slides[index+1]?.nestFilterCompares))) {
					this.sameFilteringSelection = false;
					return;
				}
			});
		}

		
		checkSelectedForFiltering() {
			if (this.selectedSlides.length === 1) {
				sb.Toplines.filters.open();
			} else {
				const questionIDs = this.selectedSlides.map(q => q.questionId);
				this.compareSlides(questionIDs);

				if (this.sameFilteringSelection) {
					sb.Toplines.filters.open();
				} else {
					this.openFilteringConfirmation();
				}
			}
		}

		checkSelectedForGrouping() {
			const questionIDs = this.questionsForGrouping.map(q => q.questionId);
			this.compareSlides(questionIDs);

			if (this.sameFilteringSelection) {
				this.groupQuestions(this.questionsForGrouping);
				this.renderQuestions(true)
			} else {
				this.openGroupingConfirmation();
			}
		}

		openFilteringConfirmation() {
			const title = 'Confirm selection';

			this.confirmFilteringWindow = new DUIwindow2({
				title: '<h2>' + locale.get(title) + '</h2>',
				cssClass: 'ags-confirm-selection',
				html: `
					<div style="border: 1px solid #f78b2a69; background: #f9e1d07a; padding: 10px; margin: 10px 2px">
						You have selected multiple questions with different filter selections. Do you want to reset the filter selections for the selected questions?
						Choose either ‘Yes’ to clear the selections or ‘No’ to keep the current selection and leave the filter options as they are.
					</div>
				`,
				width: 'auto',
				preWrapSpace: false,
				closeOnParentClick: false,
				buttons: [
					{
						text: 'No',
						onClick: () => {
							this.sameFilteringSelection = true;
						}
					},
					{
						text: 'Yes',
						focused: true,
						onClick: () => {
							sb.Toplines.filters.open();
						}
					}
				],
				afterShow: () => {
					this.bindEvents();
				},
				afterClose: () => {
					$('.auto-generate-slides-window').parent().css('visibility', '');
					this.confirmFilteringWindow = null;
					this.sameFilteringSelection = true;
				}
			});
		}

		openGroupingConfirmation() {
			const title = 'Confirm selection';

			this.confirmFilteringWindow = new DUIwindow2({
				title: '<h2>' + locale.get(title) + '</h2>',
				cssClass: 'ags-confirm-selection',
				html: `
					<div style="border: 1px solid #f78b2a69; background: #f9e1d07a; padding: 10px; margin: 10px 2px">
						You have selected multiple questions with different filter selections.
						Grouping them will reset the filter selections.
						Choose ‘Yes’ to continue the grouping process or ‘No’ to keep the current selection and leave the filter options as they are.
					</div>
				`,
				width: 'auto',
				preWrapSpace: false,
				closeOnParentClick: false,
				buttons: [
					{
						text: 'No',
						onClick: () => {
							this.sameFilteringSelection = true;
						}
					},
					{
						text: 'Yes',
						focused: true,
						onClick: () => {
							this.groupQuestions(this.questionsForGrouping);
							this.renderQuestions(true);
							this.questionsForGrouping = [];
						}
					}
				],
				afterShow: () => {
					this.bindEvents();
				},
				afterClose: () => {
					$('.auto-generate-slides-window').parent().css('visibility', '');
					this.confirmFilteringWindow = null;
					this.sameFilteringSelection = true;
				}
			});
		}

		groupQuestions(questions) {
			const questionIDs = questions.map(q => q.questionId);
			const slides = this.slides.filter(slide => slide.questionIDs.length === 1 && questionIDs.includes(slide.questionIDs[0]));
			const questionType = questions[0].questionT;
			const firstIndex = this.slides.indexOf(slides[0]);

			// remove all slides from this.slides array
			this.slides = this.slides.filter(slide => !slides.includes(slide));

			let newSlide = {
				guid: Helpers.generateGuid(),
				questionIDs: questionIDs,
				questionType: questionType,
			}

			if (this.sameFilteringSelection && (slides[0]?.filters?.length || slides[0]?.nestFilterCompares)) {
				newSlide = {
					...newSlide,
					filters: slides[0].filters || [],
					nestFilterCompares: slides[0].nestFilterCompares == null || slides[0].nestFilterCompares
				}
			}

			// add new slide to this.slides after firstSlide index
			this.slides.splice(firstIndex, 0, newSlide);
		}

		ungroupQuestions(questions) {
			for (let question of questions) {
				const slide = this.slides.find(slide => slide.questionIDs.includes(question.questionId));
				const slideIndex = this.slides.indexOf(slide);

				slide.questionIDs = slide.questionIDs.filter(id => id !== question.questionId);

				const deleteCount = slide.questionIDs.length === 0 ? 1 : 0;

				let slideData = {
					guid: Helpers.generateGuid(),
					questionIDs: [question.questionId],
					questionType: question.questionT,
				}

				if ((slide.filters?.length || slide.nestFilterCompares)) {
					slideData = {
						...slideData,
						filters: slide.filters || [],
						nestFilterCompares: slide.nestFilterCompares == null || slide.nestFilterCompares
					}
				}

				this.slides.splice(slideIndex, deleteCount, slideData);
				this.sameFilteringSelection = true;
			}
		}

		getSlideHTML(slide, showCode) {
			const { guid, questionIDs, questionType } = slide;
			const questions = questionIDs.map(id => this.getQuestionById(id));

			if (questions.length === 0) return '';

			const filteredQuestions = this.filterSelectedQuestions(questions);
			
			const headerClassName = 'ags-questions-group-header'+ (' ags-question-icon-T' + questionType);
			const footerClassName = 'ags-questions-group-footer'+ (' ags-question-icon-T' + questionType);

			const headerHTML = (questions.length > 1 && filteredQuestions.length > 0) ?
				`<div class="${headerClassName}" data-slide-guid="${guid}" data-question-type="${questionType}">Group</div>` :
				'';
			const footerHTML = (questions.length > 1 && filteredQuestions.length > 0) ?
				`<div class="${footerClassName}" data-slide-guid="${guid}"></div>` :
				'';
			
			const level = (questions.length > 1) ? 1 : 0;

			const questionsHTML = filteredQuestions.map(v => this.getQuestionHTML(v, level, guid, showCode)).join('');

			return headerHTML + questionsHTML + footerHTML;
		}

		getQuestionHTML(question, level, guid, showCode) {
			const { code, questionId, questionT, questionText, isIndexed, isCompute, isStacked } = question;

			const className = 'ags-question'+ 
				(level > 0 ? ' ags-question-grouped' : '') +
				(' questionT' + questionT + ' ags-question-icon-T' + questionT) +
				(isIndexed ? ' questionIndexed ags-question-icon-indexed' : '') +
				(isCompute ? ' questionCompute' : '') +
				(isStacked ? ' questionStacked' : '');

			const questionCode = showCode && code ? `${code} - ` : '';
			const guidAttr = guid ? ` data-slide-guid="${guid}"` : '';
			const aiIcon = question.isAicompute ? `aiicon=${Storyboard.Constants.aiIconEntity}`: '';

			return `
				<div class="${className}" data-question-id="${questionId}" data-question-type="${questionT}" data-level="${level}" ${guidAttr} ${aiIcon}>
					<span class="ags-question-name">${questionCode}${questionText}</span>
				</div>
			`;
		}

		bindQuestionsFilterActiveStatus() {
			const isFilterActive = sb.Toplines.questionsFilter.isFilterActive();
			$('#agsFilterQuestionsButton').toggleClass('active', isFilterActive);
		}

		bindQuestionsOptionsAttributes() {
			const groupedElements = $('#agsSelectedQuestions .ags-question[data-level!="0"].selected');
			const ungroupedElements = $('#agsSelectedQuestions .ags-question[data-level="0"].selected');
			const questionsForGroup = ungroupedElements
				.map((_index, el) => Number(el.dataset.questionId)).toArray()
				.map(id => this.selectedQuestions.find(q => q.questionId === id));
			
			const groupedQuestions = groupedElements
				.map((_index, el) => Number(el.dataset.questionId)).toArray()
				.map(id => this.selectedQuestions.find(q => q.questionId === id));

			this.selectedSlides = [ ...questionsForGroup, ...groupedQuestions ];

			const anyGrouped = groupedElements.length > 0;
			const multipleUngrouped = questionsForGroup.length > 1;
			const questionType = multipleUngrouped ? questionsForGroup[0].questionT : null;
			const allSameType = questionsForGroup.every(q => q.questionT === questionType);
			
			const enableGroup = multipleUngrouped && allSameType && !anyGrouped;
			const enableUngroup = anyGrouped;
			const enableFilters = questionsForGroup.length > 0 || groupedQuestions.length > 0;

			document.getElementById('agsQuestionsGroup').disabled = !enableGroup;
			document.getElementById('agsQuestionsUngroup').disabled = !enableUngroup;
			document.getElementById('agsQuestionFilters').disabled = !enableFilters;
		}

		bindEvents() {
			$(document).unbind('keyup.DUI-WINDOW-2');

			const isGroupHeaderEl = function(element) {
				return $(element).hasClass('ags-questions-group-header');
			}
			
			const isGroupedQuestionEl = function(element) {
				return $(element).hasClass('ags-question-grouped');
			}

			const groupedUngroupedQuestionsObject = (items) => {
				return $(items).filter('[data-question-id].selected')
					.toArray()
					.reduce((acc, el) => {
						const questionId = Number(el.dataset.questionId);
						const question = this.getQuestionById(questionId);

						if (isGroupedQuestionEl(el)) {
							acc.grouped[el.dataset.slideGuid] ??= [];
							acc.grouped[el.dataset.slideGuid].push(question);
						} else {
							acc.ungrouped.push(question);
						}

						return acc;
					}, {ungrouped: [], grouped: {}});
			}

			const moveQuestionInSelectedList = ($source, $anchor, position) => {
				const sourceQuestion = this.getQuestionById($source.attr('data-question-id'));
				const targetQuestion = this.getQuestionById($anchor.attr('data-question-id'));
				const sourceSlide = this.getSlideByGuid($source.attr('data-slide-guid'));
				const targetSlide = this.getSlideByGuid($anchor.attr('data-slide-guid'));
				const isSourceGroupSelected = $source.hasClass('group-selected');
				const beforeGroupHeader = position === 'BEFORE' && $anchor.hasClass('ags-questions-group-header');
				const afterGroupHeader = position === 'AFTER' && $anchor.hasClass('ags-questions-group-header');
				const beforeGroupFooter = position === 'BEFORE' && $anchor.hasClass('ags-questions-group-footer');
				const afterGroupFooter = position === 'AFTER' && $anchor.hasClass('ags-questions-group-footer');
				const isSourceGroup = sourceSlide.questionIDs.length > 1;
				const isTargetGroup = targetSlide.questionIDs.length > 1 && !afterGroupFooter && !beforeGroupHeader;

				// Move ungrouped question to new position outside groups
				if (!isSourceGroup && !isTargetGroup) {
					const sourceSlideIndex = this.slides.indexOf(sourceSlide);
					const slideToMove = this.slides.splice(sourceSlideIndex, 1)[0];
					const targetSlideIndex = this.slides.indexOf(targetSlide);
					const start = targetSlideIndex + (position === 'BEFORE' ? 0 : 1);
					this.slides.splice(start, 0, slideToMove);
				}

				// Move grouped question outside group
				if (isSourceGroup && !isTargetGroup) {
					if (isSourceGroupSelected) {
						// Move group
						const sourceSlideIndex = this.slides.indexOf(sourceSlide);
						const targetSlideIndex = this.slides.indexOf(targetSlide);

						if (sourceSlideIndex !== (targetSlideIndex + (position === 'BEFORE' ? 0 : 1))) {
							const slideToMove = this.slides.splice(sourceSlideIndex, 1)[0];
							const targetSlideIndex = this.slides.indexOf(targetSlide);
							const start = targetSlideIndex + (position === 'BEFORE' ? 0 : 1);
							this.slides.splice(start, 0, slideToMove);
						}
					} else {
						// Move question from group to ungrouped
						sourceSlide.questionIDs.splice(sourceSlide.questionIDs.indexOf(sourceQuestion.questionId), 1);

						const targetSlideIndex = this.slides.indexOf(targetSlide);
						const start = targetSlideIndex + (position === 'BEFORE' ? 0 : 1);
						this.slides.splice(start, 0, {
							guid: Helpers.generateGuid(),
							questionType: sourceQuestion.questionT,
							questionIDs: [sourceQuestion.questionId],
						});
					}
				}

				// Move ungrouped question into group
				if (!isSourceGroup && isTargetGroup) {
					if (sourceQuestion.questionT === targetSlide.questionType) {
						const sourceSlideIndex = this.slides.indexOf(sourceSlide);
						this.slides.splice(sourceSlideIndex, 1)[0];
						
						let start = 0;
						if (targetQuestion) {
							const targetQuestionIndex = targetSlide.questionIDs.indexOf(targetQuestion.questionId);
							start = targetQuestionIndex + (position === 'BEFORE' ? 0 : 1);
						} else if (afterGroupHeader) {
							start = 0;
						} else if (beforeGroupFooter) {
							start = targetSlide.questionIDs.length;
						}

						targetSlide.questionIDs.splice(start, 0, sourceQuestion.questionId);
					}
				}

				// Move grouped question into other group
				if (isSourceGroup && isTargetGroup) {
					if (sourceSlide.questionType === targetSlide.questionType) {
						const sourceQuestionIndex = sourceSlide.questionIDs.indexOf(sourceQuestion.questionId);
						sourceSlide.questionIDs.splice(sourceQuestionIndex, 1)[0];

						let start = 0;
						if (targetQuestion) {
							const targetQuestionIndex = targetSlide.questionIDs.indexOf(targetQuestion.questionId);
							start = targetQuestionIndex + (position === 'BEFORE' ? 0 : 1);
						} else if (afterGroupHeader) {
							start = 0;
						} else if (beforeGroupFooter) {
							start = targetSlide.questionIDs.length;
						}

						targetSlide.questionIDs.splice(start, 0, sourceQuestion.questionId);
					}
				}
			}

			const receiveQuestionToSelectedList = ($source, $anchor, position) => {
				const sourceQuestion = this.getQuestionById($source.attr('data-question-id'));
				const targetQuestion = this.getQuestionById($anchor.attr('data-question-id'));
				const targetSlide = this.getSlideByGuid($anchor.attr('data-slide-guid'));
				const isEmptyList = $anchor.hasClass('ags-questions-list-empty');
				const beforeGroupHeader = position === 'BEFORE' && $anchor.hasClass('ags-questions-group-header');
				const afterGroupFooter = position === 'AFTER' && $anchor.hasClass('ags-questions-group-footer');
				const isTargetGroup = !isEmptyList && 
					targetSlide && 
					targetSlide.questionIDs.length > 1 &&
					!afterGroupFooter &&
					!beforeGroupHeader;

				if (isTargetGroup) {
					if (sourceQuestion.questionT === targetSlide.questionType) {
						const targetIndex = targetQuestion ? targetSlide.questionIDs.indexOf(targetQuestion.questionId) + (position === 'BEFORE' ? 0 : 1) : 0;
						this.addQuestions([sourceQuestion], targetSlide.guid, targetIndex);
					}
				} else {
					const targetIndex = !isEmptyList && targetSlide ? this.slides.indexOf(targetSlide) + (position === 'BEFORE' ? 0 : 1) : 0;
					this.addQuestions([sourceQuestion], null, targetIndex);
				}
			}

			const removeQuestionFromSelectedList = ($source) => {
				const sourceQuestion = this.getQuestionById($source.attr('data-question-id'));
				const sourceSlide = this.getSlideByGuid($source.attr('data-slide-guid'));
				const isSourceGroup = sourceSlide.questionIDs.length > 1;

				this.removeQuestions([sourceQuestion], isSourceGroup ? sourceSlide.guid : null);
			}

			const onSort = (event, ui) => {
				const buffer = 27;
				const step = 27;
				const upper = $('#agsSelectedQuestions').get(0).getBoundingClientRect().top;
				const lower = $('#agsSelectedQuestions').get(0).getBoundingClientRect().top + $('#agsSelectedQuestions').height() - buffer;
				const current = $('#agsSelectedQuestions').scrollTop();

				if (ui.helper.get(0).getBoundingClientRect().top <= upper) {
					$('#agsSelectedQuestions').scrollTop(current - step);
					$('#agsSelectedQuestions').sortable('refreshPositions');
				} else if (ui.helper.get(0).getBoundingClientRect().top  >= lower) {
					$('#agsSelectedQuestions').scrollTop(current + step);
					$('#agsSelectedQuestions').sortable('refreshPositions');
				}
			}

			$('#agsAvailableQuestions, #agsSelectedQuestions')
				.undelegate()
				.delegate('.ags-question:not(.disabled)', 'click', function(event) {
					const row = event.currentTarget,
						$row = $(row),
						$container = $row.closest('.ags-questions-list'),
						index = $container.find('.ags-question, .ags-questions-group-header, .ags-questions-group-footer').index(row),
						clickSelPivot = $container.data('clickSelPivot'),
						isGrouped = isGroupedQuestionEl(row),
						slideGuid = row.dataset.slideGuid,
						$groupHeader = isGrouped ? $container.find(`.ags-questions-group-header[data-slide-guid="${slideGuid}"]`) : null,
						M = navigator.appVersion.indexOf("Mac") !== -1;

					if (!event.ctrlKey && !event.shiftKey && !event.metaKey) {
						$('.selected', '#agsAvailableQuestions, #agsSelectedQuestions').not(row).removeClass('selected group-selected');
						$row.removeClass('group-selected');
						$row.toggleClass('selected');

						$container.data('clickSelPivot', $row.hasClass('selected') ? index : null);
					} else if ((!M && event.ctrlKey) || (M && event.metaKey)) {
						if (!isGrouped || !$groupHeader.hasClass('selected')) {
							if ($row.hasClass('selected')) {
								$row.removeClass('selected');
							} else {
								$row.addClass('selected');
								$container.data('clickSelPivot', index);
							}
						}
					} else if (event.shiftKey) {
						if (Number.isInteger(clickSelPivot)) {
							const selectableItems = $container.find('.ags-question, .ags-questions-group-header, .ags-questions-group-footer');
							const bot = Math.min(clickSelPivot, index);
							const top = Math.max(clickSelPivot, index);
							const selectedQuestions = [];
							const selectedGroups = [];

							for (let i = bot; i <= top; i++) {
								if (!selectableItems.eq(i).hasClass('disabled')) {
									if (selectableItems.eq(i).hasClass('ags-question')) {
										selectedQuestions.push(selectableItems.eq(i).addClass('selected'));
									}
									if (selectableItems.eq(i).hasClass('ags-questions-group-header') || 
										selectableItems.eq(i).hasClass('ags-questions-group-footer')) {
											selectedGroups.push(selectableItems.eq(i));
									}
								}
							}

							selectedGroups.forEach($selectedGroupElement => {
								const slideGuid = $selectedGroupElement.attr('data-slide-guid');
								const allGroupQuestionsCount = $container.find(`.ags-question-grouped[data-slide-guid="${slideGuid}"]`).length;
								const selectedGroupQuestionsCount = selectedQuestions.filter($questionEl => $questionEl.attr('data-slide-guid') === slideGuid).length;
								
								if (selectedGroupQuestionsCount === allGroupQuestionsCount) {
									$selectedGroupElement.addClass('selected');
									selectedQuestions
										.filter($questionEl => $questionEl.attr('data-slide-guid') === slideGuid)
										.forEach($questionEl => $questionEl.addClass('selected group-selected'));
								}
							});
						}
					}

					sb.Toplines.questionsSelect.bindQuestionsOptionsAttributes();
				})
				.delegate('.ags-questions-group-header:not(.disabled)', 'click', function(event) {
					const row = event.currentTarget,
						$row = $(row),
						$container = $row.closest('.ags-questions-list'),
						slideGuid = row.dataset.slideGuid,
						index = $container.find('.ags-question, .ags-questions-group-header, .ags-questions-group-footer').index(row),
						clickSelPivot = $container.data('clickSelPivot'),
						M = navigator.appVersion.indexOf("Mac") !== -1;

					if (!event.ctrlKey && !event.shiftKey && !event.metaKey) {
						$('.selected', '#agsAvailableQuestions, #agsSelectedQuestions').not(row).removeClass('selected group-selected');
						$row.toggleClass('selected');

						$container.data('clickSelPivot', $row.hasClass('selected') ? index : null);
					} else if ((!M && event.ctrlKey) || (M && event.metaKey)) {
						if ($row.hasClass('selected')) {
							$row.removeClass('selected');
						} else {
							$row.addClass('selected');
							$container.data('clickSelPivot', index);
						}
					} else if (event.shiftKey) {
						if (!$row.hasClass('selected')) {
							$row.addClass('selected');
							$container.find(`.ags-question-grouped[data-slide-guid="${slideGuid}"]`).addClass('selected group-selected');
						}

						if (Number.isInteger(clickSelPivot)) {
							const selectableItems = $container.find('.ags-question, .ags-questions-group-header, .ags-questions-group-footer');
							const bot = Math.min(clickSelPivot, index);
							const top = Math.max(clickSelPivot, index);
							const selectedQuestions = [];
							const selectedGroups = [];

							for (let i = bot; i <= top; i++) {
								if (!selectableItems.eq(i).hasClass('disabled')) {
									if (selectableItems.eq(i).hasClass('ags-question')) {
										selectedQuestions.push(selectableItems.eq(i).addClass('selected'));
									}
									if (selectableItems.eq(i).hasClass('ags-questions-group-header') || 
										selectableItems.eq(i).hasClass('ags-questions-group-footer')) {
											selectedGroups.push(selectableItems.eq(i));
									}
								}
							}

							selectedGroups.forEach($selectedGroupElement => {
								const slideGuid = $selectedGroupElement.attr('data-slide-guid');
								const allGroupQuestionsCount = $container.find(`.ags-question-grouped[data-slide-guid="${slideGuid}"]`).length;
								const selectedGroupQuestionsCount = selectedQuestions.filter($questionEl => $questionEl.attr('data-slide-guid') === slideGuid).length;
								
								if (selectedGroupQuestionsCount === allGroupQuestionsCount) {
									$selectedGroupElement.addClass('selected');
									selectedQuestions
										.filter($questionEl => $questionEl.attr('data-slide-guid') === slideGuid)
										.forEach($questionEl => $questionEl.addClass('selected group-selected'));
								}
							});
						}
					}

					if ($row.hasClass('selected')) {
						$container.find(`.ags-question-grouped[data-slide-guid="${slideGuid}"]`).addClass('selected group-selected');
					} else {
						$container.find(`.ags-question-grouped[data-slide-guid="${slideGuid}"]`).removeClass('selected group-selected');
					}

					sb.Toplines.questionsSelect.bindQuestionsOptionsAttributes();
				});

			$('#agsAvailableQuestions').sortable('destroy').sortable({
				items: '.ags-question',
				connectWith: '#agsSelectedQuestions',
				appendTo: '#agsSteps',
				revert: false,
				cursorAt: {
					left: 0,
					top: 0
				},
				helper: function (event, item) {
					const listContainer = $(event.currentTarget);

					// make sure at least one item is selected.
					if (!item.hasClass('selected')) {
						item.addClass('selected').siblings().removeClass('selected');
					}

					const $helper = $('<div class="ags-question-list-dragging"></div>');
					const $selected = item.parent().children('.selected');
					const $cloned = $selected.clone();

					let draggingQuestionsCount = $cloned.filter('.ags-question').length;

					if (draggingQuestionsCount === 1) {
						$helper.append($cloned);
					} else {
						$helper.append(`<div class="ags-question-list-dragging-item">${draggingQuestionsCount} variables selected</div>`);
						$helper.append($cloned.hide());
					}

					$helper.append($cloned).css({
						width: listContainer.outerWidth(),
						height: '26px'
					});

					// hide it, don't remove!
					$selected.hide();

					// save the selected items
					item.data('multi-sortable-cloned', $cloned);

					listContainer.sortable('option', 'cursorAt', {
						left: event.offsetX,
						top: event.offsetY,
					});

					return $helper;
				},
				start: (event, ui) => {
					$('#agsSelectedQuestions').addClass('active');
				},
				stop: (event, ui) => {
					const $cloned = ui.item.data('multi-sortable-cloned');
					ui.item.removeData('multi-sortable');
					ui.item.after($cloned);
					ui.item.remove();

					this.renderQuestions();
					sb.Toplines.answersSelect.loadAllAnswers();

					$('#agsSelectedQuestions').removeClass('active');
				},
				sort: onSort
			});

			$('#agsSelectedQuestions').sortable('destroy').sortable({
				items: '.ags-question:not(.disabled), .ags-questions-group-header:not(.disabled), .ags-questions-group-footer:not(.disabled)',
				cancel: '.ags-questions-group-footer',
				connectWith: '#agsAvailableQuestions',
				appendTo: $('#agsSteps').closest('.DUI-WINDOW-BODY'),
				revert: false,
				cursorAt: {
					left: 0,
					top: 0
				},
				helper: function (event, item) {
					const $container = $(event.currentTarget);
					const slideGuid = item.attr('data-slide-guid');

					// make sure at least one item is selected
					if (!item.hasClass('selected')) {
						item.siblings().removeClass('selected group-selected');

						if (isGroupHeaderEl(item)) {
							item.addClass('selected');
							$container.find(`.ags-question[data-slide-guid="${slideGuid}"]`).addClass('selected group-selected');
						} else {
							item.addClass('selected');
						}
					}

					const $helper = $('<div class="ags-question-list-dragging"></div>');

					const $selected = $container.children('.selected');
					const $cloned = $selected.clone();

					let draggingQuestionsCount = $cloned.filter('.ags-question').length;

					if (draggingQuestionsCount === 1) {
						$helper.append($cloned);
					} else {
						$helper.append(`<div class="ags-question-list-dragging-item">${draggingQuestionsCount} variables selected</div>`);
						$helper.append($cloned.hide());
					}

					$helper.css({ 
						width: $container.outerWidth(),
						height: '26px'
					});

					// hide it, don't remove!
					$selected.hide();

					// save the selected items
					item.data('multi-sortable-cloned', $cloned);

					$container.sortable('option', 'cursorAt', {
						left: event.offsetX,
						top: event.offsetY,
					});

					return $helper;
				},
				start: (event, ui) => {
					$('#agsAvailableQuestions').addClass('active');
				},
				stop: (event, ui) => {
					const $cloned = ui.item.data('multi-sortable-cloned');

					if (!$cloned || $cloned.length === 0) return;

					const anchorBefore = ui.item.prev();
					const anchorAfter = ui.item.next();
					const anchor = anchorBefore.length === 1 ? anchorBefore : anchorAfter;
					const position = anchor === anchorBefore ? 'AFTER' : 'BEFORE';
					
					let draggingQuestions = $cloned.filter('.ags-question').toArray();

					if (position === 'AFTER') {
						draggingQuestions = draggingQuestions.reverse();
					}

					draggingQuestions.forEach((source) => {
						moveQuestionInSelectedList($(source), anchor, position);
					});

					ui.item.removeData('multi-sortable-cloned');
					ui.item.remove();

					this.renderQuestions();
					sb.Toplines.answersSelect.loadAllAnswers();

					$('#agsAvailableQuestions').removeClass('active');
				},
				sort: onSort,
				receive: (event, ui) => {
					const $cloned = ui.item.data('multi-sortable-cloned');

					if (!$cloned || $cloned.length === 0) return;

					const anchorBefore = ui.item.prev();
					const anchorAfter = ui.item.next();
					const anchor = anchorBefore.length === 1 ? anchorBefore : anchorAfter;
					const position = anchor === anchorBefore ? 'AFTER' : 'BEFORE';
					
					let draggingQuestions = $cloned.filter('.ags-question').toArray();

					if (position === 'AFTER') {
						draggingQuestions = draggingQuestions.reverse();
					}

					draggingQuestions.forEach((source) => {
						receiveQuestionToSelectedList($(source), anchor, position);
					});

					ui.item.removeData('multi-sortable-cloned');
					ui.item.remove();

					this.renderQuestions();
					sb.Toplines.answersSelect.loadAllAnswers();

				},
				remove: (event, ui) => {
					const $cloned = ui.item.data('multi-sortable-cloned');
					let draggingQuestions = $cloned.filter('.ags-question').toArray();

					draggingQuestions.forEach((source) => {
						removeQuestionFromSelectedList($(source));
					});

					ui.item.removeData('multi-sortable-cloned');
					ui.item.remove();

					this.renderQuestions();
					sb.Toplines.answersSelect.loadAllAnswers();
				}
			});

			$('#agsAddAllQuestions').unbind('click').bind('click', () => {
				this.addAllQuestions();
				this.renderQuestions();
				sb.Toplines.answersSelect.loadAllAnswers();
			});

			$('#agsAddQuestions').unbind('click').bind('click', (event) => {
				const questions = $('#agsAvailableQuestions .ags-question.selected')
					.map((_index, el) => Number(el.dataset.questionId)).toArray()
					.map(id => this.availableQuestions.find(q => q.questionId === id));

				this.addQuestions(questions);
				this.renderQuestions();
				sb.Toplines.answersSelect.loadAllAnswers();
			});

			$('#agsRemoveQuestions').unbind('click').bind('click', (event) => {
				var questionsObject = groupedUngroupedQuestionsObject('#agsSelectedQuestions [data-question-id].selected');

				if (questionsObject.ungrouped.length > 0)
					this.removeQuestions(questionsObject.ungrouped);

				if (Object.keys(questionsObject.grouped).length > 0) {
					Object.keys(questionsObject.grouped).forEach(guid => {
						this.removeQuestions(questionsObject.grouped[guid], guid);
					});
				}

				this.renderQuestions();
				sb.Toplines.answersSelect.loadAllAnswers();
			});

			$('#agsRemoveAllQuestions').unbind('click').bind('click', () => {
				this.removeAllQuestions();
				this.renderQuestions();
				sb.Toplines.answersSelect.loadAllAnswers();
			});

			$('#agsShowQuestionCode').unbind('change').bind('change', () => {
				this.renderQuestions();
			});

			$('#agsAvailableQuestionSearch').unbind('keyup').bind('keyup', _.debounce(this.searchAvailableQuestions.bind(this), 500));
			$('#agsSelectedQuestionSearch').unbind('keyup').bind('keyup', _.debounce(this.searchSelectedQuestions.bind(this), 250));

			$('#agsSelectedQuestions').delegate('.badge', 'click', (event) => {
				event.preventDefault();
				event.stopPropagation();

				const questionId = Number($(event.target).closest('.ags-question').attr('data-question-id'));
				if (questionId) this.openAnswers(questionId, event);
			});

			$('#agsFilterQuestionsButton').unbind('click').bind('click', (event) => {
				event.preventDefault();
				event.stopPropagation();

				if (sb.Toplines.questionsFilter.isOpen())
					sb.Toplines.questionsFilter.close();
				else
					sb.Toplines.questionsFilter.open();
			});

			$('#agsQuestionsGroup').unbind('click').bind('click', (event) => {
				this.questionsForGrouping = $('#agsSelectedQuestions .ags-question[data-question-id].selected')
					.map((_index, el) => Number(el.dataset.questionId)).toArray()
					.map(id => this.selectedQuestions.find(q => q.questionId === id));

				this.checkSelectedForGrouping();
				this.bindEvents();
			});

			$('#agsQuestionsUngroup').unbind('click').bind('click', (event) => {
				const questions = $('#agsSelectedQuestions .ags-question[data-question-id].selected')
					.map((_index, el) => Number(el.dataset.questionId)).toArray()
					.map(id => this.selectedQuestions.find(q => q.questionId === id));

				this.ungroupQuestions(questions);
				this.renderQuestions(true);
			});

			$('#agsQuestionFilters').unbind('click').bind('click', (event) => {
				this.checkSelectedForFiltering();
				this.bindEvents();
			});
		}

		getHTML() {
			return `
				<div id="agsQuestions" class="drag-drop-columns">
					<div class="drag-drop-columns__column">
						<div class="ags-questions-list-header">
							<div class="ags-questions-list-search">
								<input type="text" id="agsAvailableQuestionSearch" class="questionSelector textbox" autocomplete="off" placeholder="Search variables">
							</div>
							<div class="ags-questions-list-filter">
								<button type="button" class="linkButton" id="agsFilterQuestionsButton">Filter variables <i class="DUI-icon DUI-icon-var-filter"></i></button>
							</div>
						</div>
						<div id="agsAvailableQuestions" class="ags-questions-list ags-questions-list--available"></div>
					</div>
					<div class="drag-drop-columns__middle-menu">
						<div class="drag-drop-columns__middle-menu-item">
							<button class="drag-drop-columns__middle-menu-button" type="button" id="agsAddAllQuestions">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
								</svg>
							</button>
							<label for="agsAddAllQuestions" class="drag-drop-columns__middle-menu-button-label">Add All</label>
						</div>
						<div class="drag-drop-columns__middle-menu-item">
							<button class="drag-drop-columns__middle-menu-button" type="button" id="agsAddQuestions">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
								</svg>
							</button>
							<label for="agsAddQuestions" class="drag-drop-columns__middle-menu-button-label">Add</label>
						</div>
						<div class="drag-drop-columns__middle-menu-item">
							<button class="drag-drop-columns__middle-menu-button" type="button" id="agsRemoveQuestions">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path d="M19,13H5V11H19V13Z"></path>
								</svg>
							</button>
							<label for="agsRemoveQuestions" class="drag-drop-columns__middle-menu-button-label">Remove</label>
						</div>
						<div class="drag-drop-columns__middle-menu-item">
							<button class="drag-drop-columns__middle-menu-button" type="button" id="agsRemoveAllQuestions">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
									<path d="M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z">
									</path>
								</svg>
							</button>
							<label for="agsRemoveAllQuestions" class="drag-drop-columns__middle-menu-button-label">Remove All</label>
						</div>
					</div>
					<div class="drag-drop-columns__column">
						<div class="ags-questions-list-header">
							<div class="ags-questions-list-options">
								<button type="button" class="ags-questions-option-group DUIButtonGray" id="agsQuestionsGroup" disabled>Group</button>
								<button type="button" class="ags-questions-option-ungroup DUIButtonGray" id="agsQuestionsUngroup" disabled>Ungroup</button>
								<button type="button" class="ags-questions-option-ungroup DUIButtonGray" id="agsQuestionFilters" disabled title="Add Filters/Compare filter to selected slide(s)">Filter</button>
							</div>
							<div class="ags-questions-list-search">
								<input type="text" id="agsSelectedQuestionSearch" class="questionSelector textbox" autocomplete="off" placeholder="Search added variables">
							</div>
						</div>
						<div id="agsSelectedQuestions" class="ags-questions-list ags-questions-list--selected"></div>
					</div>
				</div>
			`;
		}
	}

	const defaultQuestionsFilterOptions = {
		questionBlocks: [],
		excludedQnTypes: '',
		hideMoreAnswers: false,
		maxNoOfAnswers: 0,
		excludeNoDataQns: false
	};

	class QuestionsFilter {
		constructor() {
			this.options = structuredClone(defaultQuestionsFilterOptions);
		}

		open() {
			if (this.isOpen()) this.close();

			$('#agsSteps').append(this.getHTML());

			this.position();
			this.bindFilterOptions();
			this.bindEvents();
		}

		position() {
			$('#agsFilterQuestions').position({
				my: 'right top',
				at: 'right top',
				of: '#agsAvailableQuestions',
				collision: 'none'
			});
		}

		close() {
			$('#agsFilterQuestions').remove();
		}

		isOpen() {
			return $('#agsFilterQuestions').length > 0;
		}

		isFilterActive() {
			return this.options.questionBlocks.length > 0 ||
				this.options.excludedQnTypes !== '' ||
				(this.options.hideMoreAnswers === true && this.options.maxNoOfAnswers > 0) ||
				this.options.excludeNoDataQns === true;
		}

		bindFilterOptions() {
			const hasQuestionBlocks = $('#lbQB option').length > 0;
			$('#agsFilterQuestions .ags-filter-question-blocks').toggle(hasQuestionBlocks);

			$('#agsQuestionBlocks')
				.html($('#lbQB option').clone())
				.val(this.options.questionBlocks);

			if (this.options.excludedQnTypes === '') {
				$('#agsVariableTypes').val('');
			} else {
				const availableVariableTypesOptions = $('#agsVariableTypes option').map((i, el) => $(el).val()).toArray();
				const selectedVariableTypesOptions = availableVariableTypesOptions.filter(qt => !this.options.excludedQnTypes.includes(qt));
				$('#agsVariableTypes').val(selectedVariableTypesOptions);
			}

			$('#agsHideMoreAnswers').attr('checked', this.options.hideMoreAnswers);
			$('#agsHideMoreAnswersValue').val(this.options.maxNoOfAnswers);
			$('#agsHideNoData').attr('checked', this.options.excludeNoDataQns);

			$('#agsFilterQuestions .ags-filter-questions-multiselect').multiselect({
				classes: "DUI-multiselect",
				header: false,
				selectedList: 5,
			});
		}

		bindEvents() {
			$(document).unbind('keyup.DUI-WINDOW-2');

			$('#agsCloseFilterQuestions').bind('click', () => this.close());

			$('#agsQuestionBlocks').bind('change', (event) => {
				this.options.questionBlocks = $(event.currentTarget).val() || [];
				sb.Toplines.questionsSelect.filterQuestions();
			});

			$('#agsVariableTypes').bind('change', (event) => {
				if ($(event.currentTarget).find('option:selected').length === 0) {
					this.options.excludedQnTypes = '';
				} else {
					this.options.excludedQnTypes = $(event.currentTarget).find('option:not(:selected)')
						.map((i, el) => $(el).val())
						.toArray()
						.join(',');
				}
				sb.Toplines.questionsSelect.filterQuestions();
			});

			$('#agsHideMoreAnswers').bind('change', (event) => {
				this.options.hideMoreAnswers = $(event.currentTarget).is(':checked');
				if (this.options.maxNoOfAnswers > 0) {
					sb.Toplines.questionsSelect.filterQuestions();
				}
			});

			$('#agsHideMoreAnswersValue').bind('blur', (event) => {
				this.options.maxNoOfAnswers = Number($(event.currentTarget).val()) || 0;
				if (this.options.hideMoreAnswers) {
					sb.Toplines.questionsSelect.filterQuestions();
				}
			});

			$('#agsHideNoData').bind('change', (event) => {
				this.options.excludeNoDataQns = $(event.currentTarget).is(':checked');
				sb.Toplines.questionsSelect.filterQuestions();
			});
		}

		getHTML() {
			return `
				<div id="agsFilterQuestions" class="DUI-OptionsPopup ags-filter-questions">
					<div class="settingsFieldsetLegend">
						<span class="ags-answers-box-title">Filter variables</span>
						<button id="agsCloseFilterQuestions" type="button" class="DUI-Setup-close ags-close-answers">×</button>
					</div>
					<div class="settingsFieldsetContent">
						<div class="settingItem ags-filter-question-blocks">
							<label class="settingsFieldSetLabel" for="agsQuestionBlocks">Question blocks</label>
							<select size="6" multiple="multiple" id="agsQuestionBlocks" class="settingControlFull ags-filter-questions-multiselect">
							</select>
						</div>
						<div class="settingItem">
							<label class="settingsFieldSetLabel" for="agsVariableTypes">Variable type</label>
							<select size="6" multiple="multiple" id="agsVariableTypes" class="settingControlFull ags-filter-questions-multiselect">
								<option value="1,2,3" title="Categorical">Categorical</option>
								<option value="5" title="Numeric">Numeric</option>
								<option value="4" title="Open ended">Open ended</option>
							</select>
						</div>
					</div>
					<div class="ags-filter-questions-divider"></div>
					<div class="settingsFieldsetContent m-t-1">
						<span class="settingItem DUI-custom-checkbox ags-hide-more-answers">
							<input type="checkbox" id="agsHideMoreAnswers">
							<label for="agsHideMoreAnswers">
								Hide questions with more then <input type="text" class="ags-hide-more-answers-value" id="agsHideMoreAnswersValue"/> answer alternatives
							</label>
						</span>
						<span class="settingItem DUI-custom-checkbox" style="display: none">
							<input type="checkbox" id="agsHideNoData">
							<label for="agsHideNoData">
								Hide variables with no data
							</label>
						</span>
					</div>
				</div>
			`;
		}
	}

	class Filters {
		constructor() {
			this.filters = [];
			this.filtersData = {
				filters: [],
				nestFilterCompares: true
			};
		}

		open() {
			if (this.isOpen()) {
				this.close();
			}
			$('#agsSteps').append('<div id="shadow" style="position: absolute;top:0;left:0;width: 100%;height:100%;z-index:2;opacity:0.4;filter: alpha(opacity = 50)"></div>');

			this.loadAllAnswers();
		}

		isOpen() {
			return $('#agsFilters').length > 0;
		}

		close() {
			this.filtersData = {
				filters: [],
				nestFilterCompares: true
			};
			sb.Toplines.questionsSelect.bindQuestionsOptionsAttributes()
			sb.Toplines.questionsSelect.sameFilteringSelection = true;
			$('#agsFilters').remove();
			$("#shadow").remove();
		}

		loadAllAnswers() {
			ChartSetupProxy.GetFilters(filters => {
				this.filters = filters;
				$('#agsSteps').append(this.getHTML());
				this.renderFilterSections(filters)
				this.bindEvents();
				this.bindSelected();
			});
		}

		renderFilterSections(filters) {
			const filterSections = $('#agsFiltersSections').empty();
			filterSections.html(Object.values(filters).map((v) => this.getFilterSectionsHTML(v)).join(''));
		}

		addFilterToQuestionsObject() {
			sb.Toplines.questionsSelect.selectedSlides.forEach((slide) => {
				const index = sb.Toplines.questionsSelect.slides.findIndex(s => s.questionIDs.includes(slide.questionId));

				if (!this.filtersData.nestFilterCompares)
					sb.Toplines.questionsSelect.slides[index] = {
						...sb.Toplines.questionsSelect.slides[index],
						nestFilterCompares: this.filtersData.nestFilterCompares
					}
				else
					delete sb.Toplines.questionsSelect.slides[index]?.nestFilterCompares;

				if (this.filtersData.filters.length)
					sb.Toplines.questionsSelect.slides[index] = {
						...sb.Toplines.questionsSelect.slides[index],
						filters: this.filtersData.filters
					}
				else
					delete sb.Toplines.questionsSelect.slides[index]?.filters;
			});
		}

		bindEvents() {
			$('#agsCloseFilters').unbind('click').bind('click', () => { this.close() });
			
			$('#agsNestCompareFilters').unbind('change').bind('change', () => {
				this.filtersData.nestFilterCompares = $('#agsNestCompareFilters')[0].checked;

				this.addFilterToQuestionsObject();
			})

			this.filters.map(filter => {
				$('#agsFiltersSection'+ filter.filterId).unbind('change').bind('change', () => {
					let selectedFilter = {
						answers: []
					};

					let selected = $('#agsFiltersSection'+ filter.filterId).val() || [];

					if ((selected.includes('clear') && selected.length == 1) || !selected.length) {
						this.filtersData.filters = this.filtersData.filters.filter(f => f.filterId !== filter.filterId);
						$('#compare'+ filter.filterId)[0].checked = false;
						this.addFilterToQuestionsObject();
						return;
					}

					if (selected.includes('clear') && selected.length > 1) {
						selected = selected.filter(sel => sel !== 'clear');
					}

					if (selected.includes('all')) {
						filter.answers.forEach(ans => {
							selectedFilter.answers.push({ answerId: ans.answerId });
						})
					} else {
						selected.forEach(ans => {
							const selectedAnswer = filter.answers.find(a => a.answerId == ans);
							selectedFilter.answers.push({ answerId: selectedAnswer.answerId });
						})
					}

					$('#compare'+ filter.filterId)[0].disabled = !selectedFilter.answers.length;
					
					const filterData = {
						allAnswers: selected.includes('all'),
						answers: selectedFilter.answers,
						filterId: filter.filterId,
						questionId: filter.questionId
					}

					const index = this.filtersData.filters?.findIndex(obj => obj.filterId === filter.filterId);

					if (index > -1) {
						this.filtersData.filters[index] = {
							...this.filtersData.filters[index],
							...filterData
						};
					} else {
						this.filtersData.filters.push(filterData);
					}

					this.addFilterToQuestionsObject();
				});

				$('#compare'+ filter.filterId).unbind('change').bind('change', () => {
					const index = this.filtersData.filters?.findIndex(obj => obj.filterId === filter.filterId);

					if (index > -1) {
						this.filtersData.filters[index] = {
							...this.filtersData.filters[index],
							compare: $('#compare'+ filter.filterId)[0].checked
						}

						this.addFilterToQuestionsObject();
					}
				})
			});
		}

		bindSelected() {
			let index = sb.Toplines.questionsSelect.slides.findIndex(s => s.questionIDs.includes(sb.Toplines.questionsSelect.selectedSlides[0].questionId));
			let slide = sb.Toplines.questionsSelect.slides[index];

			this.filters.forEach(filter => {
				const selectedFilter = slide.filters?.find(f => f.filterId === filter.filterId);

				if (!selectedFilter?.answers.length || !sb.Toplines.questionsSelect.sameFilteringSelection) {
					$('#agsFiltersSection'+ filter.filterId + ' option[value=clear]').attr('selected','selected');
				} else {
					$('#compare'+ filter.filterId)[0].disabled = !selectedFilter.answers.length;
					$('#compare'+ filter.filterId)[0].checked = selectedFilter.compare;

					selectedFilter.answers.forEach(answer => {
						$('#agsFiltersSection'+ filter.filterId + ' option[value=' + answer.answerId + ']').attr('selected','selected');
					});
				}
			});

			if (sb.Toplines.questionsSelect.sameFilteringSelection) {
				
				this.filtersData.nestFilterCompares = slide.nestFilterCompares == null || slide.nestFilterCompares;
				$('#agsNestCompareFilters')[0].checked = this.filtersData.nestFilterCompares;
				this.filtersData.filters = sb.Toplines.questionsSelect.slides[index].filters || [];
			} else {
				$('#agsNestCompareFilters')[0].checked = true;
				this.filtersData.filters = [];
				this.filtersData.nestFilterCompares = true;
				this.addFilterToQuestionsObject();
			}
		}

		getFilterSectionsHTML(filter) {
			const filterSectionOptions = filter.answers?.map(answer => {
				const { answerId, answerText } = answer;
				return `<option value="${answerId}" class="ags-answer">${answerText}</option>`
			})

			filterSectionOptions.unshift(`
				<option value="clear" class="ags-answer">No selection</option>
				<option value="all" class="ags-answer">--All--</option>
			`)

			return `
				<div
					id="filterBox"
					style="
						display: flex;
						flex-direction: column;
						gap: 5px;
						padding: 5px;
						height: 237px;
						max-height: 237px;
					"
				>
					<span style="font-weight: 600; max-width: 150px; align-content: flex-end">${filter.filterText}</span>
					<select
						id="agsFiltersSection${filter.filterId}"
						class="ags-answers-select w-100"
						multiple
						data-question-id=""
						data-filters-block-id=""
						style="height: 100%; min-width: 150px; max-width: 150px;"
					>
						${filterSectionOptions}
					</select>
					<span>
						<input id="compare${filter.filterId}" type='checkbox' name="compare" disabled/>
						<label for="compare">Compare</label>
					</span>
				</div>
			`;
		}

		getHTML() {
			return `
				<div id="agsFilters" class="DUI-OptionsPopup" style="top: 200px; left: 370px">
					<div class="settingsFieldsetLegend">
						<span>Filters</span>
						<button id="agsCloseFilters" type="button" class="DUI-Setup-close ags-close-answers">×</button>
					</div>
					<div class="settingsFieldsetContent">
						<span class="settingItem DUI-custom-checkbox">
							<input type="checkbox" id="agsNestCompareFilters">
							<label for="agsNestCompareFilters">
								Nest Compare Filters
							</label>
						</span>
						<div
							id="agsFiltersSections"
							class="ags-answers-select w-100"
							multiple
							style="
								display: grid;
								grid-template-columns: 1fr 1fr;
								flex-wrap: wrap;
								gap: 10px;
								max-height: 500px;
								overflow-y: auto;
							"
						></div>
					</div>
				</div>
			`;
		}
	}

	class AnswersSelect {
		constructor() {
			this.answers = [];
			this.filteredAnswers = [];
			this.selectedAnswers = {};
		}

		loadAllAnswers() {
			const selections = {
				selectedQuestions: sb.Toplines.questionsSelect.selectedQuestions.map(q => q.questionId),
				filter: '',
				variableSubsets: '',
				calculationType: '',
				filterByRowNo: false
			};
			ChartSetupProxy.GetAnswers(selections, (answers) => {
				this.autoSelectAllAnswers(answers);
				this.renderAnswers();
				sb.Toplines.questionsSelect.renderAnswerSelections();
				AutoGenerateSlides.validateSteps();
			});
		}

		filterAnswers() {
			const selections = {
				selectedQuestions: $('#agsAnswers').attr('data-question-id') || [],
				filter: $('#agsAnswersSearch').val() || '',
				variableSubsets: '',
				calculationType: '',
				filterByRowNo: $('#agsShowAnswerCode').is(':checked')
			};
			ChartSetupProxy.GetAnswers(selections, (answers) => this.bindAnswers(answers));
		}

		bindAnswers(answers = []) {
			this.filteredAnswers = answers;
			this.renderAnswers();
		}

		autoSelectAllAnswers(allAnswers) {
			this.answers = allAnswers;

			const answersByAnswerBlock = this.answers.reduce((acc, curr) => {
				if (!acc[curr.answerBlockId]) {
					acc[curr.answerBlockId] = [];
				}
				acc[curr.answerBlockId].push(curr);

				return acc;
			}, {});

			Object.entries(answersByAnswerBlock).forEach(([answerBlockId, answers]) => {
				if (!this.selectedAnswers[answerBlockId]) {
					this.selectedAnswers[answerBlockId] = answers.map(a => a.answerId);
				}
			});

			Object.keys(this.selectedAnswers).forEach((answerBlockId) => {
				if (!answersByAnswerBlock[answerBlockId]) {
					delete this.selectedAnswers[answerBlockId];
				}
			});
		}

		searchAnswers() {
			this.filterAnswers();
		}

		getAllSelectedAnswers() {
			return Object.values(this.selectedAnswers).flat();
		}

		renderAnswers() {
			const answersSelectEl = $('#agsAnswersSelect').empty();
			const showCode = $('#agsShowAnswerCode').is(':checked');
			const answerBlockId = Number($('#agsAnswers').attr('data-answer-block-id'));
			const ans = Number($('#agsAnswers').attr('data-ans'));
			const selectedAnswers = this.selectedAnswers[answerBlockId] || [];

			answersSelectEl.html(this.filteredAnswers.map((v) => this.getAnswerHTML(v, showCode)).join(''));
			answersSelectEl.prepend(`<option value="all">--All--</option>`);

			if (ans === selectedAnswers.length) {
				answersSelectEl.val('all');
			} else {
				answersSelectEl.val(selectedAnswers);
			}
		}

		getAnswerHTML(answer, showCode) {
			const { rowNo, answerId, answerText, answerBlockId } = answer;

			const answerCode = showCode && rowNo ? `${rowNo} - ` : '';

			return `
				<option value="${answerId}" class="ags-answer" data-question-id="${answerId}" data-answer-block-id="${answerBlockId}">
					${answerCode}${answerText}
				</option>
			`;
		}

		open(question) {
			if (this.isOpen()) this.close();

			$('#agsSteps').append(this.getHTML());

			$('#agsAnswers').attr({
				'data-question-id': question.questionId,
				'data-answer-block-id': question.answerBlockId,
				'data-ans': question.ans,
			});
			$('#agsAnswers .ags-answers-box-title').text(question.questionText);
			$('#agsAnswersSearch').val('');
			$('#agsAnswersSelect').attr('size', question.ans ? question.ans + 1 : 10);

			this.filterAnswers();
			this.position();
			this.bindEvents();
		}

		position() {
			$('#agsAnswers').position({
				my: 'center center',
				at: 'center center',
				of: '#agsQuestions',
				collision: 'none'
			});
		}

		close() {
			$('#agsAnswers').remove();
		}

		isOpen() {
			return $('#agsAnswers').length > 0;
		}

		bindEvents() {
			$(document).unbind('keyup.DUI-WINDOW-2');

			$('#agsShowAnswerCode').unbind('change').bind('change', () => { this.renderAnswers() });
			$('#agsAnswersSearch').unbind('keyup').bind('keyup', _.debounce(this.searchAnswers.bind(this), 500));
			$('#agsCloseAnswers').unbind('click').bind('click', () => { this.close() });

			$('#agsAnswersSelect').unbind('change').bind('change', () => {
				let selectedAnswers = $('#agsAnswersSelect').val() || [];
				let selectedAll = selectedAnswers.includes('all');
				let answerBlockId = Number($('#agsAnswers').attr('data-answer-block-id'));

				if (selectedAll) {
					selectedAnswers = $('#agsAnswersSelect option[value!="all"]')
						.map((_, el) => Number($(el).val()))
						.toArray();
				} else {
					selectedAnswers = selectedAnswers.filter(a => a !== 'all').map(Number);
				}

				this.selectedAnswers[answerBlockId] = selectedAnswers;

				this.renderAnswers();
				sb.Toplines.questionsSelect.renderAnswerSelections();
			});
		}

		getHTML() {
			return `
				<div id="agsAnswers" class="DUI-OptionsPopup ags-answers">
					<div class="settingsFieldsetLegend">
						<span class="ags-answers-box-title"></span>
						<button id="agsCloseAnswers" type="button" class="DUI-Setup-close ags-close-answers">×</button>
					</div>
					<div class="settingsFieldsetContent">
						<div class="m-b-1">
							<span class="DUI-custom-checkbox">
								<input type="checkbox" id="agsShowAnswerCode">
								<label for="agsShowAnswerCode">
									Show code
								</label>
							</span>
						</div>
						<div class="settingItem">
							<input type="text" id="agsAnswersSearch" class="answerSelector textbox" autocomplete="off">
						</div>
						<select id="agsAnswersSelect" class="ags-answers-select w-100" multiple data-question-id="" data-answerblock-id="" size=""></select>
					</div>
				</div>
			`;
		}
	}

	class ToplineSetSelect {
		templateSetsWindow;

		constructor() {
			this.toplineSets = [];
			this.selectedToplineSetId = null;
		}

		loadToplineSets() {
			Helpers.perfJSonCall({
				method: 'GetToplineSets',
				data: { forEdit: false },
				service: 'ReportService',
				message: 'Loading topline sets...',
				successCallback: (toplineSets) => {
					this.bindToplineSets(toplineSets);
				},
				failedCallback: () => {
					Storyboard.LayoutControls.showMessage(locale.get('Unable to load topline sets.'));
				},
				fixCasing: true
			});
		}

		bindToplineSets(templateSets) {
			this.toplineSets = templateSets;

			this.renderToplineSets();
		}

		bindEvents() {
			$(document).unbind('keyup.DUI-WINDOW-2');

			$('#agsToplineSets')
				.undelegate()
				.delegate('.ags-template-sets-list-item-name', 'click', (event) => {
					const setId = Number($(event.currentTarget).closest('.ags-template-sets-list-item').attr('data-set-id'));
					if (setId) {
						$('#agsToplineSets').attr('active-data-set-id', setId);
						$('#agsToplineSets [data-set-id].selected').removeClass('selected');
						$('#agsToplineSets [data-set-id="' + setId + '"]').addClass('selected');

						this.renderActiveToplineSet();
						this.validateSelection();
					}
				});

			$('#txtToplineSetSearch').unbind('keyup').bind('keyup', _.debounce(this.renderToplineSets.bind(this), 250));

			$('#agsActiveToplineSet')
				.undelegate()
				.delegate('button.aga-template-conditions-count', 'click', (event) => {
					const activeTemplateSet = this.getActiveTemplateSet();
					const questionType = Number($(event.currentTarget).closest('[data-question-type]').attr('data-question-type'));
					const templateSetCategory = Category(activeTemplateSet, questionType);
					templateSetCategory.preview();
				})
				.delegate('.ags-template-thumbnail', 'click', this.handleTemplateThubmnailClick.bind(this));

			$('#agsTemplateSetReview')
				.undelegate()
				.delegate('.ags-template-thumbnail', 'click', this.handleTemplateThubmnailClick.bind(this));
		}

		getActiveTemplateSet() {
			const activeTemplateSetId = Number($('#agsToplineSets').attr('active-data-set-id'));
			const activeTemplateSet = this.toplineSets.find(ts => activeTemplateSetId == ts.setId);

			return activeTemplateSet;
		}

		getSelectedTemplateSet() {
			return this.toplineSets.find(ts => this.selectedToplineSetId == ts.setId);
		}

		getSlidesAndDataObjectsNo(callback) {
			const selectedTemplateSet = this.getSelectedTemplateSet();
			if (selectedTemplateSet) {
				const slideSettings = [];
				sb.Toplines.questionsSelect.slides.forEach(function (slide) {
					var slideSetting = {
						questionIds: slide.questionIDs,
						questionType: slide.questionType,
						allAnswerQuestions: [],
						answers: []
					};

					slide.questionIDs.forEach(function (id) {
						const question = sb.Toplines.questionsSelect.getQuestionById(id);
						const answers = sb.Toplines.answersSelect.selectedAnswers[question.answerBlockId];

						if (answers) {
							for (let answer of answers)
								if (!slideSetting.answers.includes(answer))
									slideSetting.answers.push(answer);

							if (question.ans == answers.length)
								slideSetting.allAnswerQuestions.push(id);
						}
					});

					slideSettings.push(slideSetting);
				});

				Helpers.perfJSonCall({
					method: 'GetToplineSlidesEstimate',
					data: { toplineSetId: selectedTemplateSet.setId, slideSettings: slideSettings },
					service: 'ReportService',
					message: 'Loading topline sets...',
					fixCasing: true,
					successCallback: function (result) {
						$('#agsSelectedQuestions .ags-question').each((index, el) => {
							const questionId = Number($(el).attr('data-question-id'));
							if (result.unmatchedQuestions.includes(questionId))
								$(el).addClass('ags-noTemplateMatch').attr('title', 'No slide template match');
							else
								$(el).removeClass('ags-noTemplateMatch').removeAttr('title');
						});

						if (callback) callback(result);
					}
				});
			} else if (callback)
				callback({ totalSlides: 0, totalDataObjects: 0, slidesByQuestionType: [] });
		}

		open() {
			const title = 'Select Template set';

			this.templateSetsWindow = new DUIwindow2({
				title: '<h2>' + locale.get(title) + '</h2>',
				cssClass: 'ags-template-sets-window',
				html: this.getWindowContentHTML(),
				width: 'auto',
				preWrapSpace: false,
				closeOnParentClick: false,
				buttons: [
					{ text: 'Cancel' },
					{ text: 'Select', buttonId: 'agsSelectTemplateSetButton', focused: true, onClick: () => this.select() }
				],
				afterShow: () => {
					$('#agsToplineSets').attr('active-data-set-id', this.selectedToplineSetId);
					$('.ags-template-sets-window').parent().css('animation', 'none');
					$('.auto-generate-slides-window').parent().css('visibility', 'hidden');
					this.loadToplineSets();
					this.validateSelection();
					this.bindEvents();
				},
				afterClose: () => {
					$('.auto-generate-slides-window').parent().css('visibility', '');
					this.templateSetsWindow = null;
				}
			});
		}

		close() {
			if (this.templateSetsWindow) {
				this.templateSetsWindow.close();
			}
		}

		validateSelection() {
			const anyActiveTemplateSet = Boolean($('#agsToplineSets').attr('active-data-set-id'));
			$('#agsSelectTemplateSetButton').attr('disabled', !anyActiveTemplateSet);
		}

		select() {
			this.selectedToplineSetId = Number($('#agsToplineSets').attr('active-data-set-id'));
			this.renderToplineSetReview();
			AutoGenerateSlides.validateSteps();
		}

		handleTemplateThubmnailClick(event) {
			const activeTemplateSet = this.templateSetsWindow ? this.getActiveTemplateSet() : this.getSelectedTemplateSet();
			const questionType = Number($(event.currentTarget).closest('[data-question-type]').attr('data-question-type'));

			openFullSizeTemplate(activeTemplateSet, questionType);
		}

		renderToplineSets() {
			const activeTemplateSet = this.getActiveTemplateSet();
			const templateSetsList = $('#agsToplineSets .ags-template-sets-list').empty();
			const toplineSetsSearch = ($('#txtToplineSetSearch').val() ?? '').toLowerCase();

			let toplineSets = this.toplineSets.sort((a, b) => a.name.localeCompare(b.name));
			let anyCustomerTemplateSets = toplineSets.some(ts => ts.customerId > 0);
			let anyStandardTemplateSets = toplineSets.some(ts => ts.customerId === 0);

			if (toplineSetsSearch.length > 0) {
				toplineSets = toplineSets.filter(ts => {
					return ts.name.toLowerCase().includes(toplineSetsSearch);
				});
			}

			const customerToplineSets = toplineSets.filter(ts => ts.customerId !== 0);
			const standardToplineSets = toplineSets.filter(ts => ts.customerId === 0);

			$('#agsCustomerToplineSets').html(customerToplineSets.map(this.getToplineSetListItemHTML).join(''));
			$('#agsStandardToplineSets').html(standardToplineSets.map(this.getToplineSetListItemHTML).join(''));

			if (!anyCustomerTemplateSets) {
				$('#agsCustomerToplineSets').html('<p class="text-muted">You do not have any saved Template sets. Please create one, or use any of the Forsta standard template sets.</p>');
			}

			$('#agsStandardToplineSets').parent().toggle(anyStandardTemplateSets);

			if (activeTemplateSet) {
				templateSetsList.find('[data-set-id="' + activeTemplateSet.setId + '"]').addClass('selected');
				this.renderActiveToplineSet();
				this.validateSelection();
			}
		}

		renderActiveToplineSet() {
			const activeTemplateSet = this.getActiveTemplateSet();

			if (activeTemplateSet) {
				$('#agsActiveToplineSet')
					.html(this.getToplineSetHTML(activeTemplateSet));
			} else {
				$('#agsActiveToplineSet').html('<p class="ags-template-sets-main-info text-muted">Select a Template set</p>');
			}

			this.renderModifierClasses();
			this.renderThumbnails();
		}

		renderToplineSetReview() {
			const selectedTemplateSet = this.getSelectedTemplateSet();

			if (selectedTemplateSet) {
				$('#agsSelectedTemplateSetName').text(selectedTemplateSet.name);
				$('#agsTemplatesSet').text('Change Template set...');
				$('#agsTemplateSetReview')
					.html(this.getToplineSetReviewHTML(selectedTemplateSet))
					.css('display', '');

				this.renderModifierClasses();
				this.renderThumbnails();

			} else {
				$('#agsSelectedTemplateSetName').text('');
				$('#agsTemplatesSet').text('Template set...');
				$('#agsTemplateSetReview').css('display', 'none');
			}
		}

		renderSlidesAndDataObjectsNo(estimates) {
			$('.ags-template-category', '#agsTemplateSetReview').each((index, el) => {
				const questionType = Number($(el).attr('data-question-type'));
				const slidesNo = estimates.slidesByQuestionType[questionType] ?? 0;

				$(el).find('.ags-template-category-stats').text(`${slidesNo} variables/slides`);

				if (slidesNo > 0 && $(el).find('.ags-template').length === 0) {
					$(el).find('.ags-template-category-stats').text(`${slidesNo} variables`);
					$(el).find('.ags-template-category-stats').addClass('text-warning');
					$(el).find('.ags-template-category-header').after('<p class="Message Message-warning ags-template-warning m-0">Slides could not be created as the required templates are missing</p>');
				} else {
					$(el).find('.ags-template-category-stats').removeClass('text-warning');
					$(el).find('.ags-template-warning').remove();
				}
			});

			$('#agsGenerateSlidesStats').html(`<b>${estimates.totalSlides}</b> slides`);
		}

		renderModifierClasses() {
			const activeTemplateSet = this.getActiveTemplateSet();

			$('.ags-template-category', '#agsActiveToplineSet, #agsTemplateSetReview').each((i, el) => {
				const questionType = Number($(el).attr('data-question-type'));

				const defaultTemplate = getCategoryDefaultTemplate(activeTemplateSet, questionType);
				const templatesWithConditions = getCategoryTemplatesWithConditions(activeTemplateSet, questionType);

				$(el).toggleClass('ags-template-category--has-default', Boolean(defaultTemplate));
				$(el).toggleClass('ags-template-category--has-conditions', templatesWithConditions.length > 0);
			});
		}

		renderThumbnails() {
			$('.ags-template-thumbnail', '#agsActiveToplineSet, #agsTemplateSetReview')
				.unbind('error').bind('error', (event) => {
					const imageEl = event.target;
					if (imageEl.tagName == 'IMG') {
						imageEl.src = thumbnail;
					}
				})
				.each((_, el) => {
					let src = $(el).attr('data-src');
					if (src) {
						$(el).attr('src', src).removeAttr('data-src');
					}
				});
		}

		getToplineSetListItemHTML(templateSet) {
			return `
				<div class="ags-template-sets-list-item" data-set-id="${templateSet.setId}">
					<span class="ags-template-sets-list-item-name">${templateSet.name}</span>
				</div>
			`;
		}

		getTemplateHTMLByQuestionTypes(templateSet) {
			const initialQuestionTypes = { 1: '', 2: '', 3: '', 4: '', 5: '' };

			const templateHTMLByQuestionTypes = Object.keys(initialQuestionTypes).reduce((acc, questionType) => {
				const qt = Number(questionType);
				const defaultTemplate = getCategoryDefaultTemplate(templateSet, qt);
				const templatesWithConditions = getCategoryTemplatesWithConditions(templateSet, qt);
				const conditionsHTML = templatesWithConditions.length > 0 ?
					templatesWithConditions.length === 1 ?
						`<button type="button" class="linkButton aga-template-conditions-count">${templatesWithConditions.length} slide with conditions</button>` :
						`<button type="button" class="linkButton aga-template-conditions-count">${templatesWithConditions.length} slides with conditions</button>` :
					``;

				if (defaultTemplate) {
					var thumbnailUrl = "FileHandler.ashx?toplineTemplateThumbnail=true&tid=" + defaultTemplate.templateId + "&sid=" + defaultTemplate.setId;
					var templateDataURL = defaultTemplate.templateDataURL ?? '';
					acc[qt] += `
						<div class="ags-template" data-question-type="${qt}" data-template-id="${defaultTemplate.templateId}" data-slide-path="${defaultTemplate.slidePath}">
							<img class="ags-template-thumbnail" data-url="${templateDataURL}" data-src="${thumbnailUrl}" alt="${defaultTemplate.name}"/>
						</div>
					`;
				} else {
					if (templatesWithConditions.length > 0) {
						acc[qt] = `<div class="ags-template ags-template-empty">No default slide</div>`;
					} else {
						acc[qt] = `<div class="ags-template ags-template-empty">No slides</div>`;
					}
				}

				acc[qt] += `
					<div class="ags-template-info">${conditionsHTML}</div>`;

				return acc;

			}, initialQuestionTypes);

			return templateHTMLByQuestionTypes;
		}

		getToplineSetHTML(templateSet) {
			const { name, description } = templateSet;
			const templateByQuestionType = this.getTemplateHTMLByQuestionTypes(templateSet);

			return `
				<div class="ags-template-set">
					<div class="settingsFieldset">
						<div class="settingsFieldsetLegend">
							<div class="ags-template-set-name"><span>${name}</span></div>
						</div>
						<div class="ags-template-set-description">
							<p id="asgTemplateSetDescription" class="w-100 m-y-1" style="white-space: pre-wrap; word-break: break-all;">${description ?? ''}</p>
						</div>
						<div class="settingsFieldsetContent">
							<div class="ags-template-categories">
								<div class="ags-template-category" data-question-type="2">
									<div class="ags-template-category-header">
										${questionTypeIcons[2]}
										<div class="ags-template-category-name">${questionTypeText[2]}</div>
									</div>
									${templateByQuestionType[2]}
								</div>
								<div class="ags-template-category" data-question-type="3">
									<div class="ags-template-category-header">
										${questionTypeIcons[3]}
										<div class="ags-template-category-name">${questionTypeText[3]}</div>
									</div>
									${templateByQuestionType[3]}
								</div>
								<div class="ags-template-category" data-question-type="1">
									<div class="ags-template-category-header">
										${questionTypeIcons[1]}
										<div class="ags-template-category-name">${questionTypeText[1]}</div>
									</div>
									${templateByQuestionType[1]}
								</div>
								<div class="ags-template-category" data-question-type="5">
									<div class="ags-template-category-header">
										${questionTypeIcons[5]}
										<div class="ags-template-category-name">${questionTypeText[5]}</div>
									</div>
									${templateByQuestionType[5]}
								</div>
								<div class="ags-template-category" data-question-type="4">
									<div class="ags-template-category-header">
										${questionTypeIcons[4]}
										<div class="ags-template-category-name">${questionTypeText[4]}</div>
									</div>
									${templateByQuestionType[4]}
								</div>
							</div>
						</div>
					</div>
				</div>
			`;
		}

		getToplineSetReviewHTML(templateSet) {
			const templateByQuestionType = this.getTemplateHTMLByQuestionTypes(templateSet);

			return `
				<div class="ags-template-categories">
					<div class="ags-template-category" data-question-type="2">
						<div class="ags-template-category-header">
							${questionTypeIcons[2]}
							<div class="ags-template-category-name">${questionTypeText[2]}</div>
						</div>
						${templateByQuestionType[2]}
						<div class="ags-template-category-stats">0 variables/slides</div>
					</div>
					<div class="ags-template-category" data-question-type="3">
						<div class="ags-template-category-header">
							${questionTypeIcons[3]}
							<div class="ags-template-category-name">${questionTypeText[3]}</div>
						</div>
						${templateByQuestionType[3]}
						<div class="ags-template-category-stats">0 variables/slides</div>
					</div>
					<div class="ags-template-category" data-question-type="1">
						<div class="ags-template-category-header">
							${questionTypeIcons[1]}
							<div class="ags-template-category-name">${questionTypeText[1]}</div>
						</div>
						${templateByQuestionType[1]}
						<div class="ags-template-category-stats">0 variables/slides</div>
					</div>
					<div class="ags-template-category" data-question-type="5">
						<div class="ags-template-category-header">
							${questionTypeIcons[5]}
							<div class="ags-template-category-name">${questionTypeText[5]}</div>
						</div>
						${templateByQuestionType[5]}
						<div class="ags-template-category-stats">0 variables/slides</div>
					</div>
					<div class="ags-template-category" data-question-type="4">
						<div class="ags-template-category-header">
							${questionTypeIcons[4]}
							<div class="ags-template-category-name">${questionTypeText[4]}</div>
						</div>
						${templateByQuestionType[4]}
						<div class="ags-template-category-stats">0 variables/slides</div>
					</div>
				</div>
			`;
		}

		getWindowContentHTML() {
			return `
				<div class="ags-template-sets-container">
					<div class="ags-template-sets-sidebar">
						<div class="settingsFieldset">
							<div class="ags-template-sets-search m-b-1">
								<input type="text" id="txtToplineSetSearch" class="textbox searchbox fullInput" placeholder="Search Template sets">
							</div>
							<div id="agsToplineSets">
								<div class="ags-template-sets-customer">
									<div class="settingsFieldsetLegend">Your Template Sets</div>
									<div id="agsCustomerToplineSets" class="ags-template-sets-list">
									</div>
								</div>
								<div class="ags-template-sets-standard">
									<div class="settingsFieldsetLegend">Forsta Standard Template Sets</div>
									<div id="agsStandardToplineSets" class="ags-template-sets-list">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="agsActiveToplineSet" class="ags-template-sets-main">
						<p class="ags-template-sets-main-info text-muted">Select a Template set</p>
					</div>
				</div>
			`;
		}

		getHTML() {
			return `
				<div id="agsTemplateSetSelect">
					<button type="button" id="agsTemplatesSet" class="DUIbutton">Template set...</button>
				</div>
				<div id="agsTemplateSetReview" class="ags-template-set-review">
				</div>
			`;
		}
	}

	class ToplineSetSave {
		templateSetsWindow;
		mode = 'TEMPLATESETS';

		constructor() {
			this.toplineSets = [];
		}

		loadToplineSets() {
			Helpers.perfJSonCall({
				method: 'GetToplineSets',
				data: { forEdit: true },
				service: 'ReportService',
				message: 'Loading topline sets...',
				successCallback: (toplineSets) => {
					this.bindToplineSets(toplineSets);
				},
				failedCallback: () => {
					Storyboard.LayoutControls.showMessage(locale.get('Unable to load topline sets.'));
				},
				fixCasing: true
			});
		}

		saveToplineSet() {
			const data = this.toplineSets.filter(ts => ts.isUpdated || ts.isDeleted);
			if (data.length == 0) return;

			let templateSlide = null, templateElements = [], questionTokens = [];

			// only include elements if at least one template was added
			if (data.some(ts => ts.isUpdated && ts.templates.some(t => t.isUpdated && t.templateId == 0))) {
				templateSlide = Storyboard.LayoutDesigner.getCurrentSlide();
				const currentPageNo = Storyboard.LayoutDesigner.getCurrentPageNo();
				const layoutElements = Storyboard.LayoutDesigner.getLayoutElements();
				templateElements = $.grep(layoutElements, function (le) {
					return Helpers.getLayoutElementSlideIndex(le) == currentPageNo;
				});

				$(templateElements).each(function (index, elem) {
					if (!elem) return true;

					const layoutElement = this;
					const itemType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);

					// for text elements: check for used tokens and populate parameter
					if (itemType == Storyboard.Constants.itemTypes.STATICTEXT) {
						const htmlElem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.STATICTEXT, this);
						if (htmlElem?.content) {
							const questionTokenPattern = /\[.+?:[CT]\]/;
							if (questionTokenPattern.test(htmlElem.content)) {
								$(Tokens.getUsedQuestionTokens(htmlElem)).each(function () {
									questionTokens.push(this);
								});
							}
						}
					}
				});
			}

			Helpers.perfJSonCall({
				method: 'SaveToplineSets',
				data: {
					toplineSets: data,
					layoutElements: templateElements,
					layoutSlide: templateSlide,
					settings: GeneralSettings.getSelectedSettings(),
					hFilters: Storyboard.HFilterLayout.getSelectedIds("#hfilterTree"),
					questionTokens: questionTokens
				},
				service: 'ReportService',
				message: 'Saving topline sets...',
				failedCallback: () => {
					Storyboard.LayoutControls.showMessage(locale.get('Unable to save topline sets.'));
				},
				fixCasing: true
			});
		}

		bindToplineSets(templateSets) {
			this.toplineSets = templateSets;

			this.renderToplineSets();
		}

		bindEvents() {
			$(document).unbind('keyup.DUI-WINDOW-2');

			$('.ags-template-sets-window').parent().unbind('click').bind('click', Storyboard.GuiEvents.hideAllMenusAndPanels);

			$('#agsToplineSets')
				.undelegate()
				.delegate('.ags-template-sets-list-item-name', 'click', (event) => {
					const setGuid = $(event.currentTarget).closest('.ags-template-sets-list-item').attr('data-set-guid');
					if (setGuid) {
						this.closeAddCurrentSlideDropdown();
						this.setActiveTemplateSet(setGuid);
					}
				})
				.delegate('.ags-template-set-remove-button', 'click', (event) => {
					const setGuid = $(event.currentTarget).closest('.ags-template-sets-list-item').attr('data-set-guid');
					if (setGuid) {
						this.removeToplineSet(setGuid);
					}
				});

			$('#txtToplineSetSearch').unbind('keyup').bind('keyup', _.debounce(this.renderToplineSets.bind(this), 250));
			$('#btnNewToplineSet').unbind('click').bind('click', () => { this.confirmProjectOwnership(this.createNewToplineSet.bind(this)); });

			$('#asgTemplateSetNameEditButton').unbind('click').bind('click', this.handleTemplateSetNameEditClick.bind(this));
			$('#asgTemplateSetDescription').unbind('change').bind('change', this.handleTemplateSetDescriptionChange.bind(this));

			$('#agsActiveToplineSet')
				.undelegate()
				.delegate('.ags-template-add-slide', 'click', (event) => {
					const questionType = $(event.currentTarget).closest('[data-question-type]').attr('data-question-type');

					if (questionType) {
						this.closeAddCurrentSlideDropdown();
						this.openAddCurrentSlideDropdown(Number(questionType));
					}
				})
				.delegate('.ags-template-category-more-button', 'click', (event) => {
					event.stopPropagation();
					Storyboard.GuiEvents.hideAllMenusAndPanels(event);

					const categoryEl = $(event.currentTarget).closest('.ags-template-category');
					const questionType = $(categoryEl).attr('data-question-type');

					if (questionType) {
						this.openCategoryContextMenu(Number(questionType));
					}
				})
				.delegate('button.aga-template-conditions-count', 'click', (event) => {
					const activeTemplateSet = this.getActiveTemplateSet();
					const questionType = Number($(event.currentTarget).closest('[data-question-type]').attr('data-question-type'));
					const templateSetCategory = Category(activeTemplateSet, questionType);
					templateSetCategory.edit();
				})
				.delegate('.ags-template-thumbnail', 'click', this.handleTemplateThubmnailClick.bind(this));
		}

		getActiveTemplateSet() {
			const activeTemplateSetGuid = $('#agsToplineSets').attr('active-data-set-guid');
			const activeTemplateSet = this.toplineSets.find(ts => activeTemplateSetGuid == ts.guid);

			return activeTemplateSet;
		}

		getTemplateById(id) {
			const activeTemplateSet = this.getActiveTemplateSet();

			if (activeTemplateSet) {
				return activeTemplateSet.templates.find(t => t.templateId == id);
			}
		}

		getTemplateBySlidePath(slidePath) {
			const activeTemplateSet = this.getActiveTemplateSet();

			if (activeTemplateSet) {
				return activeTemplateSet.templates.find(t => t.slidePath == slidePath);
			}
		}

		getAvailableQuestionTypes() {
			const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			return currentSlide.toplineQnTypes ? currentSlide.toplineQnTypes.split(';').map(qnt => Number(qnt)) : [];
		}

		setActiveTemplateSet(setGuid) {
			$('#agsToplineSets').attr('active-data-set-guid', setGuid);
			$('#agsToplineSets [data-set-guid].selected').removeClass('selected');
			$('#agsToplineSets [data-set-guid="' + setGuid + '"]').addClass('selected');

			this.renderActiveToplineSet();
		}

		unsetActiveTemplateSet() {
			$('#agsToplineSets').removeAttr('active-data-set-guid');
			$('#agsToplineSets [data-set-guid].selected').removeClass('selected');

			this.renderActiveToplineSet();
		}

		confirmProjectOwnership(callback) {
			// Check if this project is currently assigned to Customer ID "All customer access"???
			if (window.IsAllCustomerProject) {
				new DUIwindow2({
					title: '<h2>' + locale.get('Project Ownership and Permissions') + '</h2>',
					html: `<p class="Message Message-warning">This project is currently assigned to Customer ID "All customer access". By creating this new template, it will become accessible to all Administrator users within this installation. <br/>Before proceeding with the save operation, please ensure that you have the necessary permission from the products teams to create and modify template sets associated with "All customer access".</p><p class="p-t-1">Do you wish to continue?</p>`,
					width: 520,
					closeButton: false,
					buttons: [
						{
							text: 'No',
						},
						{
							text: 'Yes',
							focused: true,
							onClick: callback
						}
					]
				});
			} else {
				callback();
			}
		}

		createNewToplineSet() {
			const newGuid = Helpers.generateGuid();
			const newToplineSet = {
				setId: 0,
				guid: newGuid,
				name: 'Template set',
				description: null,
				isEditable: true,
				isUpdated: true,
				templates: []
			}
			this.toplineSets.push(newToplineSet);
			this.renderToplineSets();
			this.setActiveTemplateSet(newGuid);
		}

		removeToplineSet(setGuid) {
			const deletedSet = this.toplineSets.find(ts => setGuid == ts.guid);
			if (deletedSet.setId > 0)
				deletedSet.isDeleted = true;
			else
				this.toplineSets = this.toplineSets.filter(ts => ts.guid != setGuid);

			if (this.activeTemplateSetGuid === setGuid) {
				this.unsetActiveTemplateSet();
			}

			this.renderToplineSets();
			this.renderActiveToplineSet();
		}

		addSlideToToplineSet(questionType) {
			const projectId = $('input[id$="hdpjt"]').val();
			const reportId = Helpers.getReportID();
			const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			const slideId = currentSlide.slideId;

			const templateSlidePath = `${projectId}-${reportId}-${slideId}`;

			const activeTemplateSet = this.getActiveTemplateSet();
			const existingTemplate = this.getTemplateBySlidePath(templateSlidePath);

			if (existingTemplate) {
				existingTemplate.isUpdated = true;
				existingTemplate.questionTypes.push({
					templateId: existingTemplate.templateId,
					questionTypeId: questionType
				});
			} else {
				const slideThumbnailCanvas = $(`#slidesPanelThumbnails .slides-panel-slide[data-guid="${currentSlide.guid}"] .slides-panel-slide-thumbnail canvas`).get(0);
				const slideDataURL = slideThumbnailCanvas ? slideThumbnailCanvas.toDataURL() : '';
				const slideMasterBg = slideThumbnailCanvas && Storyboard.LayoutDesigner.enableMasterSlideLayout ?
					slideThumbnailCanvas.style.backgroundImage.split(/"/)[1].replace("width=182", "width=160") : '';

				activeTemplateSet.templates.push({
					dataObjectsNo: 0,
					name: 'Template',
					setId: activeTemplateSet.setId,
					setGuid: activeTemplateSet.guid,
					templateId: 0,
					templateDataURL: slideDataURL,
					slideMasterBg: slideMasterBg,
					questionTypes: [{
						templateId: 0,
						questionTypeId: questionType
					}],
					isUpdated: true,
					slidePath: templateSlidePath
				})
			}
			activeTemplateSet.isUpdated = true;
		}

		removeTemplateFromToplineSet(questionType, templateId, templateSlidePath) {
			const activeTemplateSet = this.getActiveTemplateSet();

			const templateToRemove = templateId > 0 ? this.getTemplateById(templateId) : this.getTemplateBySlidePath(templateSlidePath);

			if (templateToRemove) {
				if ((templateToRemove.questionTypes && templateToRemove.questionTypes.length > 1) ||
					(templateToRemove.conditionGroups && templateToRemove.conditionGroups.length > 0)) {
					templateToRemove.isUpdated = true;
					templateToRemove.questionTypes = templateToRemove.questionTypes.filter(qt => qt.questionTypeId !== questionType);
				} else {
					templateToRemove.isDeleted = true;
					if (templateToRemove.templateId == 0)
						activeTemplateSet.templates = activeTemplateSet.templates.filter(t => t.slidePath != templateSlidePath);
				}

				activeTemplateSet.isUpdated = true;
			}
		}

		handleTemplateSetNameEditClick(event) {
			const activeTemplateSet = this.getActiveTemplateSet();
			const { name } = activeTemplateSet;
			const editNameInputEl = $(`<input type="text" value="${name}" />`)
				.bind('change', (event) => {
					const newName = $(event.currentTarget).val();

					if (newName !== name && newName !== '') {
						activeTemplateSet.name = newName;
						activeTemplateSet.isUpdated = true;
					}

					this.renderToplineSets();
					this.renderActiveToplineSet();
					$('#asgTemplateSetNameEdit').removeClass('editing');
				})
				.bind('keyup', (event) => {
					if (event.key === 'Enter') {
						$(editNameInputEl).blur();
					}
					if (event.key === 'Escape') {
						$(editNameInputEl).val(name).blur();
					}
				})
				.bind('blur', () => {
					this.renderActiveToplineSet();
					$('#asgTemplateSetNameEdit').removeClass('editing');
				});

			$('#asgTemplateSetNameEdit').html(editNameInputEl);
			$('#asgTemplateSetNameEdit').addClass('editing');

			editNameInputEl.focus().select();
		}

		handleTemplateSetDescriptionChange(event) {
			const activeTemplateSet = this.getActiveTemplateSet();
			const newDescription = event.currentTarget.value;

			activeTemplateSet.description = newDescription;
			activeTemplateSet.isUpdated = true;
		}

		handleTemplateThubmnailClick(event) {
			const activeTemplateSet = this.getActiveTemplateSet();
			const questionType = Number($(event.currentTarget).closest('[data-question-type]').attr('data-question-type'));

			openFullSizeTemplate(activeTemplateSet, questionType);
		}

		getCategoryEditingProperties(questionType) {
			const availableQuestionTypes = this.getAvailableQuestionTypes();
			const activeTemplateSet = this.getActiveTemplateSet();

			const defaultTemplate = getCategoryDefaultTemplate(activeTemplateSet, questionType);
			const templatesWithConditions = getCategoryTemplatesWithConditions(activeTemplateSet, questionType);

			const canAddSlide = this.mode === 'ADD_SLIDE' && availableQuestionTypes.includes(questionType);
			const hasDefaultSlide = Boolean(defaultTemplate);
			const hasConditionsSlides = templatesWithConditions.length > 0;

			return { canAddSlide, hasDefaultSlide, hasConditionsSlides };
		}

		openCategoryContextMenu(questionType) {
			const activeTemplateSet = this.getActiveTemplateSet();
			const defaultTemplate = getCategoryDefaultTemplate(activeTemplateSet, questionType);

			const categoryMenuItemEl = $(`#agsActiveToplineSet .ags-template-category[data-question-type="${questionType}"]`);
			const moreMenuButton = $('.ags-template-category-more-button', categoryMenuItemEl);

			const { canAddSlide, hasDefaultSlide, hasConditionsSlides } = this.getCategoryEditingProperties(questionType);

			const contextMenuEl = $(`
				<ul id="agsCategoryContextMenu" class="DUIContextMenu">
					${canAddSlide ? '<li id="agsAddCurrectSlideAsDefault"><span><em>Add current slide as default</em></span></li>' : ''}
					${canAddSlide ? '<li id="agsAddCurrectSlideWithConditions"><span><em>Add current slide with conditions</em></span></li>' : ''}
					${hasConditionsSlides ? '<li id="agsEditSlideConditions"><span><em>Edit slides conditions</em></span></li>' : ''}
					${hasDefaultSlide ? '<li id="agsRemoveDefaultSlide"><span><em>Remove default slide</em></span></li>' : ''}
				</ul>
			`)
				.delegate('#agsAddCurrectSlideAsDefault', 'click', () => {
					if (defaultTemplate) {
						const { templateId, slidePath: templateSlidePath } = defaultTemplate;
						this.removeTemplateFromToplineSet(Number(questionType), templateId, templateSlidePath);
					}
					this.addSlideToToplineSet(Number(questionType));
					this.renderActiveToplineSet();
					this.closeCategoryContextMenu();
				})
				.delegate('#agsAddCurrectSlideWithConditions', 'click', () => {
					const templateSetCategory = Category(activeTemplateSet, questionType);
					templateSetCategory.addSlideToToplineSetWithCondition();
					templateSetCategory.edit();
					this.closeCategoryContextMenu();
				})
				.delegate('#agsEditSlideConditions', 'click', () => {
					const templateSetCategory = Category(activeTemplateSet, questionType);
					templateSetCategory.edit();
					this.closeCategoryContextMenu();
				})
				.delegate('#agsRemoveDefaultSlide', 'click', () => {
					if (defaultTemplate) {
						const { templateId, slidePath: templateSlidePath } = defaultTemplate;

						this.removeTemplateFromToplineSet(questionType, templateId, templateSlidePath);
						this.renderActiveToplineSet();
					}
					this.closeCategoryContextMenu();
				});

			this.closeCategoryContextMenu();

			$('body').append(contextMenuEl);

			contextMenuEl
				.css('zIndex', 9999)
				.position({
					of: moreMenuButton,
					my: 'left top',
					at: 'right top',
					offset: '0 -1px'
				});
		}

		closeCategoryContextMenu() {
			$('#agsCategoryContextMenu').remove();
		}

		openAddCurrentSlideDropdown(questionType) {
			const availableQuestionTypes = this.getAvailableQuestionTypes();
			const singleQuestion = isSingleQuestion();
			const activeTemplateSet = this.getActiveTemplateSet();
			const defaultTemplate = getCategoryDefaultTemplate(activeTemplateSet, questionType);

			const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			const slideThumbnailCanvas = $(`#slidesPanelThumbnails .slides-panel-slide[data-guid="${currentSlide.guid}"] .slides-panel-slide-thumbnail canvas`).get(0);
			const slideDataURL = slideThumbnailCanvas ? slideThumbnailCanvas.toDataURL() : '';
			const slideMasterBg = slideThumbnailCanvas && Storyboard.LayoutDesigner.enableMasterSlideLayout ?
				slideThumbnailCanvas.style.backgroundImage.split(/"/)[1].replace("width=182", "width=160") : '';
			const defaultButtonText = defaultTemplate ? 'Replace' : 'Add'; 

			const availableQuestionTypesHTML = availableQuestionTypes.map(aqt => {
				const id = `agsAddSlideQuestionType${aqt}`;
				const value = aqt;
				const label = questionTypeText[aqt];
				const checked = aqt === questionType ? 'checked' : '';
				return `
					<div class="ags-add-slide-field">
						<input type="radio" id="${id}" name="agsAddSlideQuestionType" value="${value}" ${checked}>
						<label for="${id}">${label}</label>
					</div>
				`;
			}).join('');

			const chooseVariableTypeHTML = `
				<fieldset class="settingsFieldsetContent ags-add-slide-fieldset" style="${questionType ? 'display: none' : ''}">
					<legend>Choose variable type</legend>
					${availableQuestionTypesHTML}
				</fieldset>
			`;

			const chooseTemplateSlideTypeHTML = `
				<fieldset class="settingsFieldsetContent ags-add-slide-fieldset">
					<legend>Choose template slide type</legend>
					<div class="ags-add-slide-field">
						<input type="radio" id="agsAddSlideDefault" name="agsAddSlideTemplateType" value="Default" checked>
						<label for="agsAddSlideDefault">Default</label><br>
					</div>
					<div class="ags-add-slide-field">
						<input type="radio" id="agsAddSlideWithConditions" name="agsAddSlideTemplateType" value="WithConditions">
						<label for="agsAddSlideWithConditions">With Conditions</label><br>
					</div>
				</fieldset>
			`;

			const contextMenuEl = $(`
				<div id="agsAddSlidePopup" class="DUI-OptionsPopup ags-add-slide-popup">
					<div class="settingsFieldsetLegend">
						<span>Add current slide to template set</span>
						<button id="agsCloseAddSlideDropdown" type="button" class="DUI-OptionsPopup-close DUI-Setup-close">×</button>
					</div>
					<div class="text-center">
						<img src="${slideDataURL}" alt="Current slide" ${slideMasterBg}/>
					</div>
					<div class="settingsFieldsetContentGroup">
						${chooseVariableTypeHTML}
						${chooseTemplateSlideTypeHTML}
					</div>
					<div class="text-center">
						<button type="button" class="DUIButton" id="agsAddSlidePopupCancel">Cancel</button>
						<button type="button" class="DUIButton focused m-x-1" id="agsAddSlidePopupAdd">${defaultButtonText}</button>
					</div>
				</div>
			`)
				.delegate('#agsCloseAddSlideDropdown, #agsAddSlidePopupCancel', 'click', () => {
					this.closeAddCurrentSlideDropdown();
				})
				.delegate('#agsAddSlidePopupAdd', 'click', () => {
					const questionType = Number($('input[name="agsAddSlideQuestionType"]:checked').val());
					const addAsDefault = $('input[name="agsAddSlideTemplateType"]:checked').val() === 'Default';

					if (addAsDefault && !singleQuestion) {
						const defaultTemplate = getCategoryDefaultTemplate(activeTemplateSet, questionType);
						if (defaultTemplate) {
							const { templateId, slidePath: templateSlidePath } = defaultTemplate;
							this.removeTemplateFromToplineSet(questionType, templateId, templateSlidePath);
						}
						this.addSlideToToplineSet(questionType);
						this.renderActiveToplineSet();
					} else {
						const templateSetCategory = Category(activeTemplateSet, questionType);
						templateSetCategory.addSlideToToplineSetWithCondition(singleQuestion);
						templateSetCategory.edit();
					}

					this.closeAddCurrentSlideDropdown();
				})
				.delegate('#agsAddSlideDefault, #agsAddSlideWithConditions', 'change', () => {
					const addAsDefault = $('input[name="agsAddSlideTemplateType"]:checked').val() === 'Default';
					const actionText = addAsDefault ? defaultButtonText : 'Next';
					$('#agsAddSlidePopupAdd').text(actionText);
				});

			$('#agsCategoryContextMenu').remove();
			$('body').append(contextMenuEl);
			
			contextMenuEl
			.css('zIndex', 9999)
			.position({
				of: '#agsActiveToplineSet',
				my: 'center center',
				at: 'center center',
			});

			if (singleQuestion) {
				contextMenuEl.find('#agsAddSlideDefault').removeAttr('checked').attr('disabled', 'disabled');
				contextMenuEl.find('#agsAddSlideWithConditions').attr('checked', true);
				contextMenuEl.find('#agsAddSlideWithConditions').change();
			}

			$('#agsCloseAddSlideDropdown').focus();
		}

		closeAddCurrentSlideDropdown() {
			$('#agsAddSlidePopup').remove();
		}

		openAddSlide() {
			const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			let title = `Save slide ${currentSlide.slideIndex} to template set`;

			if (currentSlide.slideName) {
				title = `Save slide ${currentSlide.slideIndex} (${currentSlide.slideName}) to template set`;
			}

			this.mode = 'ADD_SLIDE';
			this.templateSetsWindow = new DUIwindow2({
				title: '<h2>' + title + '</h2>',
				cssClass: 'ags-template-sets-window',
				html: this.getWindowContentHTML(),
				width: 'auto',
				preWrapSpace: false,
				closeOnParentClick: false,
				buttons: [
					{ text: 'Cancel', buttonId: 'agsCancelTemplateSetButton' },
					{ text: 'Save', buttonId: 'agsSaveTemplateSetButton', focused: true, onClick: () => this.saveToplineSet() }
				],
				afterShow: () => {
					this.loadToplineSets();
					this.bindEvents();
				},
				afterClose: () => {
					this.templateSetsWindow = null;
				}
			});
		}

		openToplineSets() {
			this.mode = 'TEMPLATESETS';
			this.templateSetsWindow = new DUIwindow2({
				title: '<h2>' + locale.get('Template sets') + '</h2>',
				cssClass: 'ags-template-sets-window',
				html: this.getWindowContentHTML(),
				width: 'auto',
				preWrapSpace: false,
				closeOnParentClick: false,
				buttons: [
					{ text: 'Cancel', buttonId: 'agsCancelTemplateSetButton' },
					{ text: 'Save', buttonId: 'agsSaveTemplateSetButton', focused: true, onClick: () => this.saveToplineSet() }
				],
				afterShow: () => {
					this.loadToplineSets();
					this.bindEvents();
				},
				afterClose: () => {
					this.templateSetsWindow = null;
				}
			});
		}

		close() {
			if (this.templateSetsWindow) {
				this.templateSetsWindow.close();
			}
		}

		renderToplineSets() {
			const activeTemplateSet = this.getActiveTemplateSet();
			const templateSetsList = $('#agsToplineSets').empty();
			const toplineSetsSearch = ($('#txtToplineSetSearch').val() ?? '').toLowerCase();

			let toplineSets = this.toplineSets.filter(ts => !ts.isDeleted).sort((a, b) => a.name.localeCompare(b.name));

			if (toplineSetsSearch.length > 0) {
				toplineSets = toplineSets.filter(ts => {
					return ts.name.toLowerCase().includes(toplineSetsSearch);
				});
			}

			templateSetsList.html(toplineSets.map(this.getToplineSetListItemHTML).join(''));

			if (activeTemplateSet) {
				templateSetsList.find('[data-set-guid="' + activeTemplateSet.guid + '"]').addClass('selected');
				this.renderActiveToplineSet();
			}
		}

		renderActiveToplineSet() {
			const activeTemplateSet = this.getActiveTemplateSet();

			if (activeTemplateSet) {
				$('#agsActiveToplineSet')
					.html(this.getToplineSetHTML(activeTemplateSet));

				if (this.mode === 'TEMPLATESETS' && activeTemplateSet.templates.length === 0) {
					$('#agsActiveToplineSet .ags-template-categories').remove();
				}

			} else {
				$('#agsActiveToplineSet').html('<p class="ags-template-sets-main-info text-muted">Select Template set or create a new</p>')
			}

			this.renderModifierClasses();
			this.renderMenuButtons();
			this.renderThumbnails();
			this.bindEvents();
		}

		renderThumbnails() {
			$('.ags-template-thumbnail', '#agsActiveToplineSet')
				.unbind('error').bind('error', (event) => {
					const imageEl = event.target;
					if (imageEl.tagName == 'IMG') {
						imageEl.src = thumbnail;
					}
				})
				.each((_, el) => {
					let dataUrl = $(el).attr('data-url');
					let src = $(el).attr('data-src');

					if (dataUrl) {
						$(el).attr('src', dataUrl).removeAttr('data-url').removeAttr('data-src');
					} else if (src) {
						$(el).attr('src', src).removeAttr('data-url').removeAttr('data-src');
					}
				});
		}

		renderModifierClasses() {
			$('.ags-template-category', '#agsActiveToplineSet').each((i, el) => {
				$(el).toggleClass('ags-template-category--has-default', $(el).find('.aga-template-default-count').length > 0);
				$(el).toggleClass('ags-template-category--has-conditions', $(el).find('.aga-template-conditions-count').length > 0);
			});
		}

		renderMenuButtons() {
			$('.ags-template-category', '#agsActiveToplineSet').each((i, el) => {
				const questionType = Number($(el).attr('data-question-type'));
				const contextMenuOptions = this.getCategoryEditingProperties(questionType);

				if (Object.values((contextMenuOptions)).some(option => option === true)) {
					$(el).find('.ags-template-category-header').append(`
						<buttom type="button" class="DUIButtonIcon ags-template-category-more-button">
							<i class="DUI-icon DUI-icon-more"></i>
						</buttom>
					`);
				}
			});
		}

		getToplineSetListItemHTML(templateSet) {
			return `
				<div class="ags-template-sets-list-item" data-set-id="${templateSet.setId}" data-set-guid="${templateSet.guid}">
					<span class="ags-template-sets-list-item-name">${templateSet.name}</span>
					<span class="ags-template-sets-list-item-menu">
						<button type="button" class="DUIButtonIcon ags-template-set-remove-button" title="Remove Template Set"><i class="DUI-icon DUI-icon-trash"></i></button>
					</span>
				</div>
			`;
		}

		getTemplateHTMLByQuestionTypes(templateSet) {
			const initialQuestionTypes = { 1: '', 2: '', 3: '', 4: '', 5: '' };

			const templateHTMLByQuestionTypes = Object.keys(initialQuestionTypes).reduce((acc, questionType) => {
				const qt = Number(questionType);
				const defaultTemplate = getCategoryDefaultTemplate(templateSet, qt);
				const templatesWithConditions = getCategoryTemplatesWithConditions(templateSet, qt);
				const conditionsHTML = templatesWithConditions.length > 0 ?
					templatesWithConditions.length === 1 ?
						`<button type="button" class="linkButton aga-template-conditions-count">${templatesWithConditions.length} slide with conditions</button>` :
						`<button type="button" class="linkButton aga-template-conditions-count">${templatesWithConditions.length} slides with conditions</button>` :
					``;

				if (defaultTemplate) {
					var thumbnailUrl = "FileHandler.ashx?toplineTemplateThumbnail=true&tid=" + defaultTemplate.templateId + "&sid=" + defaultTemplate.setId;
					var templateDataURL = defaultTemplate.templateDataURL ?? '';
					acc[qt] += `
						<div class="ags-template" data-question-type="${qt}" data-template-id="${defaultTemplate.templateId}" data-slide-path="${defaultTemplate.slidePath}">
							<img class="ags-template-thumbnail" data-url="${templateDataURL}" data-src="${thumbnailUrl}" alt="${defaultTemplate.name}"/>
						</div>
					`;
				} else {
					if (templatesWithConditions.length > 0) {
						acc[qt] = `<div class="ags-template ags-template-empty">No default slide</div>`;
					} else {
						acc[qt] = `<div class="ags-template ags-template-empty">No slides</div>`;
					}
				}

				acc[qt] += `
					<div class="ags-template-info">${conditionsHTML}</div>`;

				if (this.mode === 'ADD_SLIDE') {
					const { canAddSlide } = this.getCategoryEditingProperties(qt);
					const disabled = canAddSlide ? '' : 'disabled';
					acc[qt] += `
						<div class="ags-template-action" data-question-type="${questionType}">
							<button class="DUIButton ags-template-add-slide" type="button" ${disabled}>Add current slide</button>
						</div>
					`;
				}

				return acc;

			}, initialQuestionTypes);

			return templateHTMLByQuestionTypes;
		}

		getToplineSetHTML(templateSet) {
			const { name, description } = templateSet;
			const templateByQuestionType = this.getTemplateHTMLByQuestionTypes(templateSet);

			return `
				<div class="ags-template-set">
					<div class="settingsFieldset">
						<div class="settingsFieldsetLegend">
							<div class="ags-template-set-name">
								<span id="asgTemplateSetNameEdit">${name}</span>
								<button type="button" id="asgTemplateSetNameEditButton" class="DUIButtonIcon ags-template-set-name-edit-button" title="Rename">
									<i class="DUI-icon DUI-icon-edit"></i>
								</button>
							</div>
						</div>
						<div class="ags-template-set-description">
							<textarea id="asgTemplateSetDescription" class="w-100 m-y-1" rows="3" placeholder="Description">${description ?? ''}</textarea>
						</div>
						<div class="settingsFieldsetContent">
							<div class="ags-template-categories">
								<div class="ags-template-category" data-question-type="2">
									<div class="ags-template-category-header">
										${questionTypeIcons[2]}
										<div class="ags-template-category-name">${questionTypeText[2]}</div>
									</div>
									${templateByQuestionType[2]}
								</div>
								<div class="ags-template-category" data-question-type="3">
									<div class="ags-template-category-header">
										${questionTypeIcons[3]}
										<div class="ags-template-category-name">${questionTypeText[3]}</div>
									</div>
									${templateByQuestionType[3]}
								</div>
								<div class="ags-template-category" data-question-type="1">
									<div class="ags-template-category-header">
										${questionTypeIcons[1]}
										<div class="ags-template-category-name">${questionTypeText[1]}</div>
									</div>
									${templateByQuestionType[1]}
								</div>
								<div class="ags-template-category" data-question-type="5">
									<div class="ags-template-category-header">
										${questionTypeIcons[5]}
										<div class="ags-template-category-name">${questionTypeText[5]}</div>
									</div>
									${templateByQuestionType[5]}
								</div>
								<div class="ags-template-category" data-question-type="4">
									<div class="ags-template-category-header">
										${questionTypeIcons[4]}
										<div class="ags-template-category-name">${questionTypeText[4]}</div>
									</div>
									${templateByQuestionType[4]}
								</div>
							</div>
						</div>
						<p id="agsCalculationTypesInSlide" class="Message Message-simple Message-compact text-right p-0">
						</p>
					</div>
				</div>
			`;
		}

		getWindowContentHTML() {
			return `
				<div class="ags-template-sets-container">
					<div class="ags-template-sets-sidebar">
						<div class="settingsFieldset">
							<div class="settingsFieldsetLegend">Template sets</div>
							<div class="ags-template-set-new">
								<input type="button" id="btnNewToplineSet" class="linkButton addNew" value="New template set">
							</div>
						</div>
						<div class="settingsFieldset ags-template-sets-fieldset">
							<div class="ags-template-sets-search">
								<input type="text" id="txtToplineSetSearch" class="textbox searchbox fullInput" placeholder="Search">
							</div>
							<div id="agsToplineSets" class="ags-template-sets-list">
							</div>
						</div>
					</div>
					<div id="agsActiveToplineSet" class="ags-template-sets-main">
						<p class="ags-template-sets-main-info text-muted">Select Template set or create a new</p>
					</div>
				</div>
			`;
		}
	}

	function openFullSizeTemplate(templateSet, questionType) {
		const categoriesOrder = [2, 3, 1, 5, 4];
		const items = [];

		for (let i = 0; i < categoriesOrder.length; i++) {
			const defaultTemplate = getCategoryDefaultTemplate(templateSet, categoriesOrder[i]);
			if (defaultTemplate) {
				items.push({index: i, questionType: categoriesOrder[i], template: defaultTemplate});
			}
		}

		let index = items.indexOf(items.find(item => item.questionType === questionType ));

		if (index === -1) return;

		function getImgUrl(template) {
			return "FileHandler.ashx?toplineTemplateThumbnail=true&tid=" + template.templateId + "&sid=" + template.setId;
		}

		function getTitleContentHtml(item) {
			return '<h2>' + getQuestionTypeText(item.questionType) + '</h2>';
		}

		function getBodyContentHtml() {
			const budyHTML = "<img id='zoomedTemplateThumbnail' class='blockCenter marginTop20' src='../images/spinner.gif'>";
			return budyHTML;
		}

		function getQuestionTypeText(questionType) {
			return $('.ags-template-category[data-question-type="' + questionType + '"]', '#agsActiveToplineSet, #agsTemplateSetReview')
				.find('.ags-template-category-name')
				.first()
				.text() || '';
		}

		function loadImg(template) {
			const zoomedImg = new Image();
			zoomedImg.id = "zoomedTemplateThumbnail";
			zoomedImg.className = "blockCenter marginTop20";
			zoomedImg.style.maxWidth = "100%";

			zoomedImg.onload = function () {
				$(imgDialog.windowEl).css({
					'width': (this.width + 72),
				}).find('#zoomedTemplateThumbnail').replaceWith(this);
			};

			zoomedImg.onerror = function () {
				$(imgDialog.windowEl)
					.find('#zoomedTemplateThumbnail')
					.replaceWith('<p class="Message Message-error">Failed to load template image</p>');
			};

			if (template.templateId === 0) {
				const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
				const slidesPanelSlide = $(`#slidesPanelThumbnails .slides-panel-slide[data-guid="${currentSlide.guid}"]`).data('slide');

				if (slidesPanelSlide) {
					slidesPanelSlide._renderThumbnailImageFromLayoutElements(true, currentSlide.width, false)
						.then(canvas => {
							zoomedImg.src = canvas.toDataURL();

							if (Storyboard.LayoutDesigner.enableMasterSlideLayout) {
								const slideMasterBg = canvas.style.backgroundImage.split(/"/)[1].replace("width=182", "width=" + currentSlide.width);
								zoomedImg.style.backgroundImage = `url(${slideMasterBg})`;
							}
						});
				}
			} else {
				zoomedImg.src = getImgUrl(template);
			}
		}

		function navigateTemplates(direction) {
			let newItem;

			if (direction === "prev") newItem = items[index - 1];
			else if (direction === "next") newItem = items[index + 1];

			if (newItem) {
				index = items.indexOf(newItem);

				$(imgDialog.windowEl).find('.DUI-WINDOW-HEADER').html(getTitleContentHtml(newItem));
				$(imgDialog.windowEl).find('.DUI-WINDOW-BODY').html(getBodyContentHtml());
				loadImg(newItem.template);
				validateNavigation();
			}
		}

		function validateNavigation() {
			$("#btnPrevTemplate").toggle(index > 0);
			$("#btnNextTemplate").toggle(index + 1 < items.length);
		}

		function dialogAfterShow() {
			loadImg(items[index].template);

			$(this.windowEl).find('.DUI-WINDOW-BODY')
				.after('<button type="button" id="btnPrevTemplate" class="DUIButtonIcon prevZoomedTemplate" title="Previous">' +
					'<i class="DUI-icon DUI-icon-c-left"></i>' +
					'</button>' +
					'<button type="button" id="btnNextTemplate" class="DUIButtonIcon nextZoomedTemplate" title="Next">' +
					'<i class="DUI-icon DUI-icon-c-right"></i>' +
					'</button>');

			$("#btnPrevTemplate").bind("click", function () { navigateTemplates("prev"); });
			$("#btnNextTemplate").bind("click", function () { navigateTemplates("next"); });

			$(document).bind("keydown.imgDialog", function (evt) {
				switch (evt.which) {
					case 37: // left arrow
						navigateTemplates("prev");
						break;
					case 39: // right arrow
						navigateTemplates("next");
						break;
					default:
						return;
				}
				evt.preventDefault();
			});

			validateNavigation();
		}

		function dialogAfterClose() {
			$(document).unbind("keydown.imgDialog");
		}

		var imgDialog = new DUIwindow2({
			title: getTitleContentHtml(items[index]),
			html: getBodyContentHtml(),
			buttons: [],
			cssClass: "zoomedTemplateWindow",
			afterShow: dialogAfterShow,
			afterClose: dialogAfterClose
		});
	}

	const Category = function (templateSetArg, questionType) {
		const templateSet = structuredClone(templateSetArg);
		let mode = 'TEMPLATESETS';

		const LogicalOperator = {
			All: 0,
			Any: 1
		}

		const LogicalOperatorLabel = {
			[LogicalOperator.All]: 'All',
			[LogicalOperator.Any]: 'Any',
		}

		const ComparisonOperator = {
			Equal: 0,
			NotEqual: 1,
			GreaterThan: 2,
			LessThan: 3,
			GreaterEqual: 4,
			LessEqual: 5,
			In: 6,
			NotIn: 7,
			Contains: 8,
			StartsWith: 9,
			EndsWith: 10,
			DoesNotContain: 11
		}

		const ComparisonOperatorLabel = {
			[ComparisonOperator.Equal]: 'Equal to',
			[ComparisonOperator.NotEqual]: 'Not equal to',
			[ComparisonOperator.GreaterThan]: 'Greater than',
			[ComparisonOperator.LessThan]: 'Less than',
			[ComparisonOperator.GreaterEqual]: 'Greater than or equal to',
			[ComparisonOperator.LessEqual]: 'Less than or equal to',
			[ComparisonOperator.In]: 'In the list',
			[ComparisonOperator.NotIn]: 'Not in the list',
			[ComparisonOperator.Contains]: 'Contains',
			[ComparisonOperator.StartsWith]: 'Starts with',
			[ComparisonOperator.EndsWith]: 'Ends with',
			[ComparisonOperator.DoesNotContain]: 'Does not contain',
		}

		const Property = {
			NumberOfQuestions: 4,
			NumberOfAnswers: 0,
			QuestionTag: 1,
			QuestionText: 2,
			QuestionCode: 3,
		}

		const PropertyLabel = {
			[Property.NumberOfQuestions]: 'Number of selected questions',
			[Property.NumberOfAnswers]: 'Number of selected answers',
			[Property.QuestionTag]: 'Question tag',
			[Property.QuestionText]: 'Question text',
			[Property.QuestionCode]: 'Question code',
		}

		const propertyOperators = {
			[Property.NumberOfAnswers]: [
				ComparisonOperator.Equal,
				ComparisonOperator.NotEqual,
				ComparisonOperator.GreaterThan,
				ComparisonOperator.LessThan,
				ComparisonOperator.GreaterEqual,
				ComparisonOperator.LessEqual,
			],
			[Property.QuestionTag]: [
				ComparisonOperator.Equal,
				ComparisonOperator.NotEqual,
				ComparisonOperator.Contains,
				ComparisonOperator.DoesNotContain,
				ComparisonOperator.StartsWith,
				ComparisonOperator.EndsWith,
				ComparisonOperator.In,
				ComparisonOperator.NotIn,
			],
			[Property.QuestionText]: [
				ComparisonOperator.Equal,
				ComparisonOperator.NotEqual,
				ComparisonOperator.Contains,
				ComparisonOperator.DoesNotContain,
				ComparisonOperator.StartsWith,
				ComparisonOperator.EndsWith,
				ComparisonOperator.In,
				ComparisonOperator.NotIn,
			],
			[Property.QuestionCode]: [
				ComparisonOperator.Equal,
				ComparisonOperator.NotEqual,
				ComparisonOperator.Contains,
				ComparisonOperator.DoesNotContain,
				ComparisonOperator.StartsWith,
				ComparisonOperator.EndsWith,
				ComparisonOperator.In,
				ComparisonOperator.NotIn,
			],
			[Property.NumberOfQuestions]: [
				ComparisonOperator.Equal,
				ComparisonOperator.NotEqual,
				ComparisonOperator.GreaterThan,
				ComparisonOperator.LessThan,
				ComparisonOperator.GreaterEqual,
				ComparisonOperator.LessEqual,
			]
		};

		function generateConditionGroup(template) {
			const templatesWithConditions = getCategoryTemplatesWithConditions(templateSet, questionType);
			const newGuid = Helpers.generateGuid();

			return {
				templateId: template.templateId,
				questionTypeId: questionType,
				conditionGroupId: 0,
				conditionGroupGuid: newGuid,
				sortOrder: templatesWithConditions.length + 1,
				logicalOperator: LogicalOperator.All,
				conditions: [],
			}
		}

		function generateCondition(conditionGroup) {
			const newGuid = Helpers.generateGuid();

			return {
				conditionId: 0,
				conditionGuid: newGuid,
				conditionGroupId: conditionGroup.conditionGroupId,
				conditionGroupGuid: conditionGroup.conditionGroupGuid,
				property: null,
				operator: null,
				value: null,
			}
		}

		function getTemplateBySlidePath(slidePath) {
			return templateSet.templates.find(t => t.slidePath === slidePath);
		}

		function getTemplateById(id) {
			return templateSet.templates.find(t => t.templateId === Number(id));
		}

		function getConditionGroup(id, guid) {
			if (templateSet.templates)
				for (let template of templateSet.templates)
					if (template.conditionGroups)
						for (let conditionGroup of template.conditionGroups) {
							if (id && id > 0 && Number(id) === conditionGroup.conditionGroupId) return conditionGroup;
							if (guid && guid === conditionGroup.conditionGroupGuid) return conditionGroup;
						}

			return null;
		}

		function getCondition(id, guid) {
			if (templateSet.templates)
				for (let template of templateSet.templates)
					if (template.conditionGroups)
						for (let conditionGroup of template.conditionGroups)
							if (conditionGroup.conditions)
								for (let condition of conditionGroup.conditions) {
									if (id && id > 0 && Number(id) === condition.conditionId) return condition;
									if (guid && guid === condition.conditionGuid) return condition;
								}

			return null;
		}

		function getConditionByElement(el) {
			const conditionId = $(el).attr('data-condition-id');
			const conditionGuid = $(el).attr('data-condition-guid');
			return getCondition(conditionId, conditionGuid);
		}

		function getConditionGroupByElement(el) {
			const conditionGroupId = $(el).attr('data-condition-group-id');
			const conditionGroupGuid = $(el).attr('data-condition-group-guid');
			return getConditionGroup(conditionGroupId, conditionGroupGuid);
		}

		function edit() {
			mode = 'ADD_SLIDE';
			renderCategory();
		}

		function preview() {
			mode = 'TEMPLATESETS';
			renderCategory();
		}

		function close() {
			if (sb.Toplines.toplineSetSave?.templateSetsWindow)
				sb.Toplines.toplineSetSave.renderActiveToplineSet();
			
			if (sb.Toplines.toplineSetSelect?.templateSetsWindow)
				sb.Toplines.toplineSetSelect.renderActiveToplineSet();

			$('.DUI-WINDOW-BUTTONS', '.ags-template-sets-window, .ags-template-sets-window').css('display', '');
		}

		function done() {
			Object.assign(templateSetArg, templateSet);
			close();
		}

		function addSlideToToplineSetAsDefault() {
			const projectId = $('input[id$="hdpjt"]').val();
			const reportId = Helpers.getReportID();
			const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			const slideId = currentSlide.slideId;

			const templateSlidePath = `${projectId}-${reportId}-${slideId}`;

			const existingTemplate = getTemplateBySlidePath(templateSlidePath);

			if (existingTemplate) {
				existingTemplate.isUpdated = true;
				existingTemplate.questionTypes = existingTemplate.questionTypes || [];
				existingTemplate.questionTypes.push({
					templateId: existingTemplate.templateId,
					questionTypeId: questionType
				});
			} else {
				const slideThumbnailCanvas = $(`#slidesPanelThumbnails .slides-panel-slide[data-guid="${currentSlide.guid}"] .slides-panel-slide-thumbnail canvas`).get(0);
				const slideDataURL = slideThumbnailCanvas ? slideThumbnailCanvas.toDataURL() : '';
				const slideMasterBg = slideThumbnailCanvas && Storyboard.LayoutDesigner.enableMasterSlideLayout ?
					slideThumbnailCanvas.style.backgroundImage.split(/"/)[1].replace("width=182", "width=160") : '';

				templateSet.templates.push({
					dataObjectsNo: 0,
					name: 'Template',
					setId: templateSet.setId,
					setGuid: templateSet.guid,
					templateId: 0,
					templateDataURL: slideDataURL,
					slideMasterBg: slideMasterBg,
					questionTypes: [{
						templateId: 0,
						questionTypeId: questionType
					}],
					isUpdated: true,
					slidePath: templateSlidePath
				})
			}
			templateSet.isUpdated = true;
		}

		function addSlideToToplineSetWithCondition(isSingleQuestion) {
			const projectId = $('input[id$="hdpjt"]').val();
			const reportId = Helpers.getReportID();
			const currentSlide = Storyboard.LayoutDesigner.getCurrentSlide();
			const slideId = currentSlide.slideId;

			const templateSlidePath = `${projectId}-${reportId}-${slideId}`;

			const existingTemplate = getTemplateBySlidePath(templateSlidePath);

			if (existingTemplate) {
				existingTemplate.conditionGroups = existingTemplate.conditionGroups || [];

				const newConditionGroup = generateConditionGroup(existingTemplate);
				const newCondition = generateCondition(newConditionGroup);

				existingTemplate.conditionGroups.push(
					Object.assign(newConditionGroup, { conditions: [newCondition] }
					));

				existingTemplate.isUpdated = true;
			} else {
				const slideThumbnailCanvas = $(`#slidesPanelThumbnails .slides-panel-slide[data-guid="${currentSlide.guid}"] .slides-panel-slide-thumbnail canvas`).get(0);
				const slideDataURL = slideThumbnailCanvas ? slideThumbnailCanvas.toDataURL() : '';
				const slideMasterBg = slideThumbnailCanvas && Storyboard.LayoutDesigner.enableMasterSlideLayout ?
					slideThumbnailCanvas.style.backgroundImage.split(/"/)[1].replace("width=182", "width=160") : '';

				const newTemplate = {
					dataObjectsNo: 0,
					name: 'Template',
					setId: templateSet.setId,
					setGuid: templateSet.guid,
					templateId: 0,
					templateDataURL: slideDataURL,
					slideMasterBg: slideMasterBg,
					questionTypes: [],
					conditionGroups: [],
					isUpdated: true,
					slidePath: templateSlidePath
				}

				const newCondition = addNewConditionToConditionGroup(addNewConditionGroupToTemplate(newTemplate));
				if (isSingleQuestion) {
					newCondition.property = Property.NumberOfQuestions;
					newCondition.value = 1;
					newCondition.operator = ComparisonOperator.Equal;
					newCondition.isStatic = true;
				}

				templateSet.templates.push(newTemplate);
			}

			templateSet.isUpdated = true;
		}

		function removeCategoryDefaultTemplate() {
			const templateToRemove = getCategoryDefaultTemplate(templateSet, questionType);

			if (templateToRemove) {
				if ((templateToRemove.questionTypes && templateToRemove.questionTypes.length > 1) ||
					(templateToRemove.conditionGroups && templateToRemove.conditionGroups.length > 0)) {
					templateToRemove.isUpdated = true;
					templateToRemove.questionTypes = templateToRemove.questionTypes.filter(qt => qt.questionTypeId !== questionType);
				} else {
					templateToRemove.isDeleted = true;
					if (templateToRemove.templateId == 0)
						templateSet.templates = templateSet.templates.filter(t => t.slidePath != templateToRemove.slidePath);
				}

				templateSet.isUpdated = true;
			}
		}

		function addNewConditionGroupToTemplate(template) {
			const newConditionGroup = generateConditionGroup(template);
			template.conditionGroups.push(newConditionGroup);
			return newConditionGroup;
		}

		function addNewConditionToConditionGroup(conditionGroup) {
			const newCondition = generateCondition(conditionGroup);
			conditionGroup.conditions.push(newCondition);
			conditionGroup.isUpdated = true;
			return newCondition;
		}

		function removeConditionGroup(conditionGroup) {
			const template = getTemplateById(conditionGroup.templateId);
			const index = template.conditionGroups.indexOf(conditionGroup);
			if ((template.questionTypes && template.questionTypes.length > 0) || (template.conditionGroups && template.conditionGroups.length > 1)) {
				template.isUpdated = true;
			} else {
				template.isDeleted = true;
				if (template.templateId == 0)
					templateSet.templates = templateSet.templates.filter(t => t.slidePath != template.slidePath);
			}
			templateSet.isUpdated = true;
			template.conditionGroups.splice(index, 1);
		}

		function removeCondition(condition) {
			if (condition.isStatic)
				return;
			const conditionGroup = getConditionGroup(condition.conditionGroupId, condition.conditionGroupGuid);
			const index = conditionGroup.conditions.indexOf(condition);
			conditionGroup.conditions.splice(index, 1);
			conditionGroup.isUpdated = true;
		}

		function setConditionUpdated(condition) {
			condition.isUpdated = true;
			const conditionGroup = getConditionGroup(condition.conditionGroupId, condition.conditionGroupGuid);
			conditionGroup.isUpdated = true;
			const template = getTemplateById(conditionGroup.templateId);
			template.isUpdated = true;
			templateSet.isUpdated = true;
		}

		function validateCategory() {
			const templatesWithConditions = getCategoryTemplatesWithConditions(templateSet, questionType);
			let isValid = true;

			for (let template of templatesWithConditions) {
				for (let conditionGroup of template.conditionGroups) {
					for (let condition of conditionGroup.conditions) {
						if (Object.values(Property).includes(condition.property)) {
							switch (condition.property) {
								case Property.NumberOfAnswers:
								case Property.NumberOfQuestions:
									if (!condition.value || condition.value < 1) {
										isValid = false;
									}
									break;
								case Property.QuestionTag:
									if (!condition.value || condition.value === '') {
										isValid = false;
									}
									break;
							}
						} else {
							isValid = false;
						}
					}
				}
			}

			$('#agsCategory .ags-category-done').attr('disabled', !isValid);
		}

		function renderCategory() {
			$('#agsActiveToplineSet').html(getCategoryHTML());

			$('#agsActiveToplineSet .ags-category-header-name').text(questionTypeText[questionType]);

			renderTemplatesWithConditions();

			if (mode === 'ADD_SLIDE') {
				$('#agsCategoryGuide').html("<p>When auto-generating slides, the first matching template is applied; reorder templates with drag and drop. If multiple questions are on the same slide, Question Code/Text/Tag conditions apply if any, not all, questions fulfill them. If the questions on an auto-generated slide don't match any conditions, the default template is applied.</p>");
				$('#agsCategory .ags-category-done').css('display', '');
				validateCategory();
			} else {
				$('#agsCategory .ags-category-done').remove();
				$('#agsCategoryGuide').html("<p>When auto-generating slides, the first matching template is applied. If multiple questions are on the same slide, Question Code/Text/Tag conditions apply if any, not all, questions fulfill them. If the questions on an auto-generated slide don't match any conditions, the default template is applied.</p>");
			}

			$('.DUI-WINDOW-BUTTONS', '.ags-template-sets-window, .ags-template-sets-window').css('display', 'none');

			renderDefaultTemplate();
		}

		function bindEvents() {
			$('#agsCategory .ags-category-cancel').unbind('click').bind('click', close);
			$('#agsCategory .ags-category-done').unbind('click').bind('click', done);

			$('#agsCategory').undelegate();

			$('#agsCategory .ags-category-condition-templates')
				.sortable('destroy')
				.sortable({
					items: '.ags-condition-group',
					handle: ".ags-condition-group-drag-handle",
					axis: "y",
					stop: (event, ui) => {
						const conditionGroups = $('#agsCategory .ags-condition-group').map((index, el) => {
							return getConditionGroupByElement(el);
						}).toArray();

						for (let i = 0; i < conditionGroups.length; i++) {
							conditionGroups[i].sortOrder = i + 1;
							conditionGroups[i].isUpdated = true;
							var template = getTemplateById(conditionGroups[i].templateId);
							template.isUpdated = true;
						}
						templateSet.isUpdated = true;
						renderTemplatesWithConditions();
					},
				});

			$('#agsCategory')
				.delegate('.ags-condition-group-remove', 'click', (event) => {
					const conditionGroup = getConditionGroupByElement($(event.target).closest('.ags-condition-group'));
					removeConditionGroup(conditionGroup);
					renderTemplatesWithConditions();
					validateCategory();
				})
				.delegate('.ags-conditions-logical-operator-select', 'change', (event) => {
					const conditionGroup = getConditionGroupByElement($(event.target).closest('.ags-condition-group'));
					conditionGroup.logicalOperator = Number($(event.target).val());
					conditionGroup.isUpdated = true;
					var template = getTemplateById(conditionGroup.templateId);
					template.isUpdated = true;
					templateSet.isUpdated = true;
					renderTemplatesWithConditions();
				})
				.delegate('.ags-condition-and, .ags-condition-or', 'click', (event) => {
					const condition = getConditionByElement($(event.target).closest('.ags-condition'));
					const conditionGroup = getConditionGroup(condition.conditionGroupId, condition.conditionGroupGuid);
					addNewConditionToConditionGroup(conditionGroup);
					renderTemplatesWithConditions();
					validateCategory();

				})
				.delegate('.ags-condition-remove', 'click', (event) => {
					const condition = getConditionByElement($(event.target).closest('.ags-condition'));
					removeCondition(condition);
					renderTemplatesWithConditions();
					validateCategory();
				})
				.delegate('.ags-condition-property', 'change', (event) => {
					const condition = getConditionByElement($(event.target).closest('.ags-condition'));
					condition.property = Number($(event.target).val());
					if (!condition.operator) {
						condition.operator = propertyOperators[condition.property][0];
					}
					setConditionUpdated(condition);
					renderTemplatesWithConditions();
					validateCategory();
					$(`#agsCategory .ags-condition[data-condition-guid="${condition.conditionGuid}"] .ags-condition-value`).focus();
				})
				.delegate('.ags-condition-operator', 'change', (event) => {
					const condition = getConditionByElement($(event.target).closest('.ags-condition'));
					condition.operator = Number($(event.target).val());
					setConditionUpdated(condition);
					renderTemplatesWithConditions();
					validateCategory();
					$(`#agsCategory .ags-condition[data-condition-guid="${condition.conditionGuid}"] .ags-condition-value`).focus();
				})
				.delegate('.ags-condition-value', 'keyup change', (event) => {
					const condition = getConditionByElement($(event.target).closest('.ags-condition'));
					condition.value = $(event.target).val();
					setConditionUpdated(condition);
					validateCategory();
				})
				.delegate('.ags-category-default-template-add', 'click', (event) => {
					addSlideToToplineSetAsDefault();
					renderDefaultTemplate();
				})
				.delegate('.ags-category-default-template-remove', 'click', (event) => {
					removeCategoryDefaultTemplate();
					renderDefaultTemplate();
				});
		}

		function renderDefaultTemplate() {
			const defaultTemplate = getCategoryDefaultTemplate(templateSet, questionType);
			const defaultTemplateElements = getDefaultTemplateElements(defaultTemplate);

			const agsCategory = $('#agsCategory');
			const targetEl = agsCategory.find('.ags-category-default-template');

			if (targetEl.length) {
				targetEl.replaceWith(defaultTemplateElements);
			} else {
				agsCategory.find('.ags-category-content').append(defaultTemplateElements);
			}

			renderThumbnails();
			bindEvents();

			if (isSingleQuestion())
				$('.ags-category-default-template-add').attr('disabled', 'disabled');
		}

		function renderTemplatesWithConditions() {
			const templatesWithConditions = getCategoryTemplatesWithConditions(templateSet, questionType);
			const templatesWithConditionsElement = getTemplatesWithConditionsElement(templatesWithConditions);

			const agsCategory = $('#agsCategory');
			const targetEl = agsCategory.find('.ags-category-condition-templates');

			if (targetEl.length) {
				targetEl.css('height', targetEl.height());
				targetEl.replaceWith(templatesWithConditionsElement);
				targetEl.css('height', '');
			} else {
				agsCategory.find('.ags-category-content').prepend(templatesWithConditionsElement);
			}

			setupNumericInputs();
			renderThumbnails();
			bindEvents();
		}

		function renderThumbnails() {
			$('.ags-category-thumbnail', '#agsActiveToplineSet')
				.unbind('error').bind('error', (event) => {
					const imageEl = event.target;
					if (imageEl.tagName == 'IMG') {
						imageEl.src = thumbnail;
					}
				})
				.each((_, el) => {
					let dataUrl = $(el).attr('data-url');
					let src = $(el).attr('data-src');

					if (dataUrl) {
						$(el).attr('src', dataUrl).removeAttr('data-url').removeAttr('data-src');
					} else if (src) {
						$(el).attr('src', src).removeAttr('data-url').removeAttr('data-src');
					}
				});
		}
		
		function setupNumericInputs() {
			$('.ags-condition-value[type="number"]', '#agsActiveToplineSet').each((_index, element) => {
				Helpers.setupIntegerInput(element);
			});
		}

		function getDefaultTemplateElements(defaultTemplate) {
			if (defaultTemplate) {
				const template = document.getElementById('ags-category-default-template');
				const content = template.content.cloneNode(true);
				content.querySelector('.ags-category-template-slide').append(getThumbnailElement(defaultTemplate));

				if (mode !== 'ADD_SLIDE') {
					content.querySelector('.ags-category-default-template-remove').remove();
				}

				return content;

			} else {
				let template;

				if (mode === 'ADD_SLIDE' && Storyboard.Toplines.toplineSetSave?.mode === 'ADD_SLIDE') {
					template = document.getElementById('ags-category-default-template-empty');
				} else {
					template = document.getElementById('ags-category-default-template-empty-preview');
				}

				const content = template.content.cloneNode(true);
				return content;
			}
		}

		function getThumbnailElement(template) {
			const { templateId, setId, name = '', templateDataURL = '' } = template;
			const thumbnailUrl = templateId ?
				"FileHandler.ashx?toplineTemplateThumbnail=true&tid=" + templateId + "&sid=" + setId :
				'';

			const img = document.createElement('img');

			img.className = 'ags-category-thumbnail';
			img.alt = name;
			img.setAttribute('data-url', templateDataURL);
			img.setAttribute('data-src', thumbnailUrl);

			return img;
		}

		function getTemplatesWithConditionsElement(templatesWithConditions) {
			if (templatesWithConditions.length === 0) return '';

			const templateThumbnails = {};

			const conditionGroups = templatesWithConditions
				.flatMap(twc => {
					const conditionGroups = twc.conditionGroups.filter(cg => cg.questionTypeId === questionType);

					if (!templateThumbnails[twc.templateId]) {
						templateThumbnails[twc.templateId] = getThumbnailElement(twc).outerHTML;
					}

					return conditionGroups;
				})
				.sort((a, b) => a.sortOrder - b.sortOrder);

			const conditionGroupsElements = conditionGroups
				.map(cg => getConditionGroupElements(cg, templateThumbnails[cg.templateId]));

			const conditionsGroupsEl = document.createElement('div');

			conditionsGroupsEl.className = 'ags-category-condition-templates';
			conditionsGroupsEl.append(...conditionGroupsElements);

			return conditionsGroupsEl;
		}

		function getConditionGroupElements(conditionGroup, thumbnailHTML) {
			if (!conditionGroup) return '';

			const conditionsCount = conditionGroup.conditions.length;
			const conditionElements = conditionGroup.conditions
				.map((condition, index) => {
					const { logicalOperator } = conditionGroup;
					const isLastCondition = index === conditionsCount - 1;
					return mode === 'ADD_SLIDE' ?
						getConditionEditElements(condition, logicalOperator, conditionsCount, isLastCondition) :
						getConditionPreviewElements(condition, logicalOperator, conditionsCount, isLastCondition);
				});

			let logicalOperatorHTML = '';

			if (conditionGroup.logicalOperator === LogicalOperator.All) {
				if (mode === 'ADD_SLIDE') {
					logicalOperatorHTML = `
						Match
						<select class="ags-conditions-logical-operator-select">
							<option value="0" selected>${LogicalOperatorLabel[LogicalOperator.All]}</option>
							<option value="1">${LogicalOperatorLabel[LogicalOperator.Any]}</option>
						</select>
						conditions:
					`;
				} else {
					logicalOperatorHTML = 'Match all conditions:'
				}
			} else if (conditionGroup.logicalOperator === LogicalOperator.Any) {
				if (mode === 'ADD_SLIDE') {
					logicalOperatorHTML = `
						Match
						<select class="ags-conditions-logical-operator-select">
						<option value="0">${LogicalOperatorLabel[LogicalOperator.All]}</option>
						<option value="1" selected>${LogicalOperatorLabel[LogicalOperator.Any]}</option>
						</select>
						condition:
					`;
				} else {
					logicalOperatorHTML = 'Match any condition:'
				}
			}

			const template = document.getElementById('ags-condition-group');
			const content = template.content.cloneNode(true);

			if (mode === 'ADD_SLIDE') {
				content.querySelector('.ags-condition-group').classList.toggle('ags-condition-group--current', conditionGroup.conditionGroupId === 0);
				content.querySelector('.ags-category-template-slide').setAttribute('data-tag', conditionGroup.conditionGroupId === 0 ? 'New' : '');
			} else {
				content.querySelector('.ags-condition-group-drag-handle').remove();
				content.querySelector('.ags-condition-group-remove').remove();
			}

			content.querySelector('.ags-condition-group').setAttribute('data-condition-group-id', conditionGroup.conditionGroupId);
			content.querySelector('.ags-condition-group').setAttribute('data-condition-group-guid', conditionGroup.conditionGroupGuid);

			content.querySelector('.ags-category-template-slide').innerHTML = thumbnailHTML;
			content.querySelector('.ags-conditions-logical-operator').innerHTML = logicalOperatorHTML;
			content.querySelector('.ags-category-template-content').append(...conditionElements);

			return content;
		}

		function getConditionEditElements(condition, logicalOperator, conditionsCount, isLastCondition) {
			function addButton() {
				if (isLastCondition) {
					if (logicalOperator === LogicalOperator.All) {
						return '<button type="button" class="DUIButtonIcon ags-condition-and p-0" title="Add"><i class="DUI-icon DUI-icon-add"></i></button>';
					} else if (logicalOperator === LogicalOperator.Any) {
						return '<button type="button" class="DUIButtonIcon ags-condition-or p-0" title="Or"><i class="DUI-icon DUI-icon-add"></i></button>';
					}
				} else {
					if (logicalOperator === LogicalOperator.All || condition.isStatic) {
						return '<span>And</span>';
					} else if (logicalOperator === LogicalOperator.Any) {
						return '<span>Or</span>';
					}
				}
				return '';
			}

			function removeButton() {
				if (conditionsCount > 1 && !condition.isStatic) {
					return '<button type="button" class="DUIButtonIcon ags-condition-remove" title="Remove condition"><i class="DUI-icon DUI-icon-remove"></i></button>';
				} else {
					return '<button type="button" class="DUIButtonIcon ags-condition-remove" title="Remove condition" disabled><i class="DUI-icon DUI-icon-remove"></i></button>';
				}
			}

			const conditionEl = document.createElement('div');

			conditionEl.className = 'ags-condition';

			conditionEl.setAttribute('data-condition-id', condition.conditionId);
			conditionEl.setAttribute('data-condition-guid', condition.conditionGuid);

			const conditionProperty = document.createElement('div');
			conditionProperty.append(getConditionPropertyElement(condition));

			const conditionOperator = document.createElement('div');
			conditionOperator.append(getConditionOperatorElement(condition));

			const conditionValue = document.createElement('div');
			conditionValue.append(getConditionValueElement(condition));

			const conditionButtons = document.createElement('div');
			conditionButtons.innerHTML = addButton() + removeButton();

			conditionEl.append(
				conditionProperty,
				conditionOperator,
				conditionValue,
				conditionButtons,
			);

			return conditionEl;
		}

		function getConditionPreviewElements(condition, logicalOperator, conditionsCount, isLastCondition) {
			const conditionEl = document.createElement('div');

			conditionEl.className = 'ags-condition';

			conditionEl.setAttribute('data-condition-id', condition.conditionId);
			conditionEl.setAttribute('data-condition-guid', condition.conditionGuid);

			const conditionProperty = document.createElement('div');
			conditionProperty.append(PropertyLabel[condition.property]);

			const conditionOperator = document.createElement('div');
			conditionOperator.append(ComparisonOperatorLabel[condition.operator]);

			const conditionValue = document.createElement('div');
			conditionValue.append(condition.value ?? '');

			conditionEl.append(
				conditionProperty,
				conditionOperator,
				conditionValue,
			);

			return conditionEl;
		}

		function getConditionPropertyElement(condition) {
			const isAnswerBased = (qt) => qt === 1 || qt === 2 || qt === 3;

			const select = document.createElement('select');
			select.className = 'ags-condition-property';
			select.name = 'agsConditionProperty';

			const option = document.createElement("option");
			select.append(option);

			for (const value of Object.keys(Property)) {
				if (value === 'NumberOfAnswers' && !isAnswerBased(questionType)) continue;
				const option = document.createElement("option");
				option.value = Property[value];
				option.textContent = PropertyLabel[Property[value]];
				option.selected = Property[value] === condition.property;
				if (option.selected) {
					option.setAttribute('selected', 'selected');
				}
				select.append(option);
			}

			if (condition.isStatic)
				select.disabled = true;

			return select;
		}

		function getConditionOperatorElement(condition) {
			const select = document.createElement('select');
			select.className = 'ags-condition-operator';
			select.name = 'agsConditionOperator';

			const option = document.createElement("option");
			select.append(option);

			if (condition.property in propertyOperators) {
				for (const value of propertyOperators[condition.property]) {
					const option = document.createElement("option");
					option.value = value;
					option.textContent = ComparisonOperatorLabel[value];
					option.selected = value === condition.operator;
					if (option.selected) {
						option.setAttribute('selected', 'selected');
					}
					select.append(option);
				}

				if (condition.isStatic)
					select.disabled = true;
			} else {
				select.disabled = true;
			}

			return select;
		}

		function getConditionValueElement(condition) {
			const inputEl = document.createElement('input');

			inputEl.className = 'ags-condition-value';
			inputEl.name = 'agsConditionValue';

			switch (condition.property) {
				case Property.NumberOfAnswers:
				case Property.NumberOfQuestions:
					inputEl.type = 'number';
					inputEl.min = 0;
					inputEl.setAttribute('value', condition.value ?? 0);
					break;
				case Property.QuestionTag:
				case Property.QuestionCode:
				case Property.QuestionText:
					inputEl.type = 'text';
					inputEl.setAttribute('value', condition.value ?? '');
					break;
				default:
					inputEl.type = 'text';
					inputEl.disabled = true;
			}

			if (condition.operator == ComparisonOperator.In || condition.operator == ComparisonOperator.NotIn) {
				inputEl.placeholder = 'e.g., value1, value2, value3';
			}

			if (condition.isStatic)
				inputEl.disabled = true;

			return inputEl;
		}

		function getCategoryHTML() {
			return `
				<div id="agsCategory" class="ags-template-set ags-category">
					<div class="settingsFieldset">
						<div class="settingsFieldsetLegend ags-category-header">
							<div class="ags-category-header-name"></div>
							<div class="ags-category-header-buttons">
								<button type="button" class="linkButton ags-category-cancel"><i class="DUI-icon DUI-icon-a-left"></i> Back</button>
								<button type="button" class="DUIbutton focused ags-category-done" style="display: none">Done</button>
							</div>
						</div>
						<div class="ags-category-guide">
							<div id="agsCategoryGuide"></div>
						</div>
						<div class="settingsFieldsetContent ags-category-content">
						</div>
						<div class="settingsFieldsetLegend ags-category-footer">
							<div class="ags-category-footer-buttons">
								<button type="button" class="linkButton ags-category-cancel"><i class="DUI-icon DUI-icon-a-left"></i> Back</button>
								<button type="button" class="DUIbutton focused ags-category-done" style="display: none">Done</button>
							</div>
						</div>
					</div>
					<template id="ags-condition-group">
						<div class="ags-condition-group" data-condition-group-id="" data-condition-group-guid="">
							<div class="ags-condition-group-drag-handle">
								<i class="DUI-icon DUI-icon DUI-icon-drag"></i>
							</div>
							<div class="ags-category-template-slide"></div>
							<div class="ags-category-template-content">
								<div class="ags-category-template-header">
									<div class="ags-conditions-logical-operator"></div>
									<button type="button" class="DUIButtonIcon ags-condition-group-remove m-r-1" title="Remove conditions group">
										<i class="DUI-icon DUI-icon-trash"></i>
									</button>
								</div>
							</div>
						</div>
					</template>
					<template id="ags-category-default-template">
						<div class="ags-category-default-template">
							<div class="ags-category-template-slide"></div>
							<div class="ags-category-template-content">
								<div class="ags-category-default-name">Default template</div>
								<div>
									<button type="button" class="DUIButtonIcon ags-category-default-template-remove m-r-1" title="Remove default template">
										<i class="DUI-icon DUI-icon-trash"></i>
									</button>
								</div>
							</div>
						</div>
					</template>
					<template id="ags-category-default-template-preview">
						<div class="ags-category-default-template">
							<div class="ags-category-template-slide"></div>
							<div class="ags-category-template-content">
								<div class="ags-category-default-name">Default template</div>
							</div>
						</div>
					</template>
					<template id="ags-category-default-template-empty">
						<div class="ags-category-default-template">
							<div class="ags-category-template-content">
								<button type="button" class="linkButton ags-category-default-template-add">
									<i class="DUI-icon DUI-icon--left DUI-icon-add"></i> Add current slide as default
								</button>
							</div>
						</div>
					</template>
					<template id="ags-category-default-template-empty-preview">
						<div class="ags-category-default-template">
							<div class="ags-category-template-content">
								No default slide
							</div>
						</div>
					</template>
				</div>
			`;
		}

		return {
			edit,
			preview,
			close,
			addSlideToToplineSetWithCondition
		};
	};

	const AutoGenerateSlides = (function () {
		const title = 'Autogenerate slides';
		let autoGenerateSlidesWindow;

		function generateSlides() {
			const toplineSetId = sb.Toplines.toplineSetSelect.selectedToplineSetId;
			const slideNameType = Number($('#agsGenerateSlidesNamesButtons > button.active').val());
			const slideSettings = [];

			sb.Toplines.questionsSelect.slides.forEach(function(slide) {
				var slideSetting = {
					questionIds: slide.questionIDs,
					questionType: slide.questionType,
					allAnswerQuestions: [],
					answers: []
				};

				if (slide.nestFilterCompares != null && !slide.nestFilterCompares)
					slideSetting.nestFilterCompares = slide.nestFilterCompares;

				if (slide.filters != null && slide.filters.length > 0)
					slideSetting.filters = slide.filters;

				slide.questionIDs.forEach(function(id) {
					const question = sb.Toplines.questionsSelect.getQuestionById(id);
					const answers = sb.Toplines.answersSelect.selectedAnswers[question.answerBlockId];

					if (answers) {
						for (let answer of answers)
							if (!slideSetting.answers.includes(answer))
								slideSetting.answers.push(answer);

						if (question.ans == answers.length)
							slideSetting.allAnswerQuestions.push(id);
					}
				});

				slideSettings.push(slideSetting);
			});

			Helpers.perfJSonCall({
				method: "GenerateToplineSlides",
				service: "ReportService",
				message: "Generating slides...",
				data: { toplineSetId: toplineSetId, slideSettings: slideSettings, slideNameType: slideNameType },
				successCallback: function (toplines) {
					Storyboard.TemplatesLibrary.appendTemplateContent(toplineSetId, toplines, Storyboard.Constants.TemplateItemTypes.Report, false, true);

					Storyboard.Toplines.AutoGenerateSlides.close();
					Storyboard.LayoutDesigner.loadStorytellerContentForElements(toplines.layoutElements);
				},
				failCallback: function () {
					Storyboard.LayoutControls.showMessage(locale.get("Unable to generate topline slides."));
				},
				fixCasing: true
			});
		}

		function open() {
			sb.Toplines.questionsFilter = new QuestionsFilter();
			sb.Toplines.questionsSelect = new QuestionsSelect();
			sb.Toplines.answersSelect = new AnswersSelect();
			sb.Toplines.filters = new Filters();
			sb.Toplines.toplineSetSelect = new ToplineSetSelect();

			autoGenerateSlidesWindow = new DUIwindow2({
				cssClass: 'auto-generate-slides-window',
				title: '<h2>' + locale.get(title) + '</h2>',
				html: getHTML(sb.Toplines.questionsSelect.getHTML(), sb.Toplines.toplineSetSelect.getHTML()),
				width: 1280,
				preWrapSpace: false,
				closeOnParentClick: false,
				buttons: [],
				afterShow: () => {
					sb.Toplines.questionsSelect.bindQuestionsFilterActiveStatus();
					sb.Toplines.questionsSelect.loadQuestions();
					bindEvents();
				},
				afterClose: () => {
					$('.auto-generate-slides-window').parent().css('visibility', '');
					autoGenerateSlidesWindow = null;
					sb.Toplines.questionsSelect = null;
					sb.Toplines.answersSelect = null;
					sb.Toplines.toplineSetSelect = null;
				}
			});
		}

		function close() {
			if (autoGenerateSlidesWindow) {
				autoGenerateSlidesWindow.close();
			}
		}

		function bindEvents() {
			$(document).unbind('keyup.DUI-WINDOW-2');

			$('#agsTemplatesSet').unbind('click').bind('click', () => sb.Toplines.toplineSetSelect.open());
			$('#agsGenerateSlides').unbind('click').bind('click', () => generateSlides());

			$('#agsSteps').closest('.DUI-WINDOW-OUTER').unbind('mousedown').bind('mousedown', (event) => {
				if (sb.Toplines.answersSelect.isOpen()) {
					if (($(event.target).closest('.DUI-OptionsPopup').length == 0) &&
						($(document.activeElement).filter('input[type="text"]').closest('.DUI-OptionsPopup').length == 0)) {
						sb.Toplines.answersSelect.close();
					}
				}

				if (sb.Toplines.questionsFilter.isOpen()) {
					if (($(event.target).closest('.DUI-OptionsPopup').length == 0) &&
						($(document.activeElement).filter('input[type="text"]').closest('.DUI-OptionsPopup').length == 0) &&
						$('#agsFilterQuestions .ui-multiselect.ui-state-active').length == 0) {
						Storyboard.Toplines.questionsFilter.close();
					}
				}
			});

			$('#agsGenerateSlidesNamesButtons > button').unbind('click').bind('click', (event) => {
				$('#agsGenerateSlidesNamesButtons > button.active').removeClass('active');
				$(event.target).addClass('active');
			});
		}

		function validateSteps() {
			const isSelectedToplineSet = sb.Toplines.toplineSetSelect?.selectedToplineSetId !== null;
			const anySelectedQuestions = sb.Toplines.questionsSelect && sb.Toplines.questionsSelect.selectedQuestions.length > 0;
			sb.Toplines.toplineSetSelect.getSlidesAndDataObjectsNo(function (result) {
				const slidesLimit = 200;

				$('#agsStepsSlideTemplate').attr('disabled', !anySelectedQuestions && !isSelectedToplineSet);
				$('#agsStepsGenerateSlides').attr('disabled', !anySelectedQuestions || !isSelectedToplineSet || (result.totalSlides > slidesLimit));

				$('#agsGenerateSlidesStats').css('display', anySelectedQuestions && isSelectedToplineSet ? '' : 'none');

				if (result.totalSlides > slidesLimit) {
					$('#agsGenerateSlidesValidation').text(`Up to ${slidesLimit} slides can be created.`).addClass('Message Message-error');
				} else {
					$('#agsGenerateSlidesValidation').text('').removeClass('Message Message-error');
				}

				sb.Toplines.toplineSetSelect.renderSlidesAndDataObjectsNo(result);
			});
		}

		function getHTML(questionsSelectHTML, toplineSetSelectHTML) {
			return `
				<p class="lead m-0 p-b-1">
					Generate slides in 3 simple steps: add variables, select a template set, and start generating. Up to 200 slides can be created.
				</p>
				<p class="m-0 p-b-1">
					By default, a slide will be generated for each selected variable. To report multiple variables on the same slide, use the Group function. <br/>
					Note that only variables of the same type can be added to the same group.
				</p>
				<div id="agsSteps" class="ags-steps">
					<fieldset class="settingsFieldset ags-steps-fieldset">
						<div class="settingsFieldsetLegend">
							<span class="icon-count saved-data"></span><span>Add variables</span>
							<div class="ags-questions-show-code DUI-custom-checkbox">
								<input type="checkbox" id="agsShowQuestionCode">
								<label for="agsShowQuestionCode">
									Show code
								</label>
							</div>
						</div>
						<div id="agsSelectQuestions" class="settingsFieldsetContent ags-steps-content">
							${questionsSelectHTML}
						</div>
					</fieldset>
					<fieldset id="agsStepsSlideTemplate" class="settingsFieldset ags-steps-fieldset" disabled>
						<div class="settingsFieldsetLegend">
							<span class="icon-count saved-data"></span><span>Select slide Template set</span>
							<span id="agsSelectedTemplateSetName" class="ags-selected-template-set-name"></span>
						</div>
						<div id="agsSelectSlideTemplate" class="settingsFieldsetContent ags-steps-content">
							<div class="ags-step-slide-template">
								${toplineSetSelectHTML}
							</div>
						</div>
					</fieldset>
					<fieldset id="agsStepsGenerateSlides" class="settingsFieldset ags-steps-fieldset" disabled>
						<div class="settingsFieldsetLegend">
							<span class="icon-count saved-data"></span><span>Generate slides</span>
							<p id="agsGenerateSlidesStats" class="ags-generate-slides-stats" style="display: none">
								<b>54</b> slides with <b>146</b> data objects
							</p>
						</div>
						<div class="settingsFieldsetContent ags-steps-content">
							<div class="ags-step-generate-slides-names">
								<span>Slide names</span>
								<div id="agsGenerateSlidesNamesButtons" class="DUIButtonsGroup topline-slide-names-buttons">
									<button type="button" class="DUIButtonGray active" value="0">No Name</button><!--
									--><button type="button" class="DUIButtonGray" value="1">Question Text</button><!--
									--><button type="button" class="DUIButtonGray" value="2">Question Code</button><!--
									--><button type="button" class="DUIButtonGray" value="3">Question Code + Question Text</button>
								</div>
							</div>
							<div class="ags-step-generate-slides">
								<button type="button" id="agsGenerateSlides" class="DUIbutton focused">Generate</button>
								<p class="ags-generate-slides-validation"><span id="agsGenerateSlidesValidation" class="m-0"></span></p>
							</div>
						</div>
					</fieldset>
				</div>
			`;
		}

		return {
			open,
			close,
			validateSteps
		};
	})();

	sb.Toplines.AutoGenerateSlides = AutoGenerateSlides;
	sb.Toplines.questionsSelect = null;
	sb.Toplines.answersSelect = null;
	sb.Toplines.toplineSetSelect = null;
	sb.Toplines.toplineSetSave = new ToplineSetSave();

})(window.Storyboard = (window.Storyboard || {}));